export default {
  system: {
    name: 'Admin',
    home: 'Dashboard',
    signOut: 'Sign Out',
    myAccount: 'My Account',
    systemLanguage: 'System Language',
    Chinese: 'Chinese',
    English: 'English',
    loggedOut: 'Your login has expired,Please log in again.',
    confirmLogout: 'Confirm Log Out',
    login: 'Login',
    logPass: 'Password Login',
    SMSLogin: 'SMS Login',
    sendCode: 'Get Verification Code',
    Resend: 'Get Again',
    welcomeBack: 'Welcome Back',
    systemName: 'HURIX',
    title: 'HURIX Admin Management',
    areNotCustomerService: 'You are not customer service and do not have access to this information',
    noPermission: 'You do not have permission to access.',
    noIp: 'IP information not obtained',
    forgotPass: 'Forgot password',
    Expired: 'Expired',
    failedIdentityInformation: 'Failed to retrieve identity information. Please contact the platform support for assistance.',
    reconnect: 'Attempting to reconnect...',
    ProductSpecificationIdentifier: 'Product Specification ID',
    mobileOrEmail: 'Enter mobile number or email',
    Continue: 'Continue',
    unreadSystemNotifications: 'Unread notifications - Click here ',
    sureLogout: 'Are you sure log out of the system?',
    NoData: 'No Data',
    PleaseUploadPictures: 'Please upload pictures',
    connectQuickBooks: 'Connect QuickBooks',
    customerService: 'Support',
  },
  table: {
    filter: 'Current Filter',
    dataList: 'Data List',
    id: 'ID',
    function: 'Actions',
    ViewAddress: 'View Address',
    productImage: 'Product Image',
    yodelServiceCentre: 'Yodel ServiceCentre & local areas',
    postcodeDistrict: 'Postcode district',
    total: 'Total: x',
    pageSize: '/page',
    serialNum: "No.",
    completionTime: 'Completion Time',
  },
  common: {
    warning: 'Warning',
    cancelled: 'Cancelled'
  },
  button: {
    refresh: 'Refresh',
    or: 'or',
    save: 'Save',
    search: 'Search',
    reset: 'Reset',
    more: 'More',
    download: 'Download',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    upload: 'Upload',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    submit: 'Submit',
    edit: 'Edit',
    clear: 'Clear',
    details: 'Details',
    view: 'View',
    viewDetails: 'View Details',
    log: 'Log',
    add: 'Add',
    back: 'Back',
    select: 'Select',
    Review: 'Review',
    changeRecord: 'Change Record',
    contactSeller: 'Contact Seller',
    viewProduct: 'View Product',
    Change: 'Change',
    Expand: 'Expand',
    Collapse: 'Collapse',
    Recharge: 'Recharge',
    preview: 'Preview',
    previewProduct: 'Preview Product',
  },
  payment: {
    topUpAmount: 'Top-up Amount',
    pleaseSelectOrEnterValidTopUpAmount: 'Please select or enter a valid top-up amount',
    customAmount: 'Custom Amount',
    amountCannotExceed: 'Top-up amount cannot exceed £999,999',
    other: 'Other',
    selectPaymentMethod: 'Select Payment Method',
    ConfirmPay: 'Confirm Payment',
    cancelPayment: 'Cancel Payment',
    paymentNotSuccessful: 'Payment was not successful',
    paymentDeclined: 'The payment has been declined',
    wasNotCharged: 'Your payment was not processed',
    SomeCommonIssues: 'Some common issues include:',
    VerifyPaymentInformation: 'Verify payment information',
    bankHaveFlagged: 'Payment provider has flagged the transaction',
    withdrawalPurchaseLimits: 'Payment limits or restrictions',
    ProcessingPayment: 'Processing payment',
    committedProtectingInformation: 'We are committed to protecting your information',
    PaymentSuccessful: 'Payment Successful',
    pleaseEnterValidAmount: 'Please enter a valid amount',
    PleaseSelectPaymentMethod: 'Please select a payment method',
    stripePayment: 'Stripe Payment',
    wechatPayment: 'WeChat Payment',
    paymentAmount: 'Payment Amount',
    scanQrCode: 'Please use WeChat to scan the QR code below to pay',
    qrCodeExpired: 'QR code has expired',
    qrCodeValidity: 'QR code validity period',
    loadingQrCode: 'Loading payment QR code...',
    paymentSuccess: 'Payment Successful',
    paymentSuccessMessage: 'Your payment has been successfully processed',
    confirmPaymentSuccess: 'Confirm'
  },
  permission: {
    roleName: 'Role Name',
    status: 'Status',
    roleType: 'Role Type',
    AssignMenus: 'Assign Menus',
    enable: 'Enable',
    disable: 'Disable',
  },
  ums: {
    userId: 'User ID',
    userName: 'User Name',
    email: 'Email',
    phone: 'Phone',
    password: 'Password',
    resetPassword: 'Reset Password',
    createdTime: 'Created Time',
    LastModifiedTime: 'Last Modified Time',
    notes: 'Notes',
    description: 'Description',
    administratorType: 'Administrator Type',
    createdBy: 'Created By',
    yes: 'Yes',
    no: 'No',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    menuName: 'Menu Name',
    menuNamezh: 'Menu Name (CN)',
    menuNameen: 'Menu Name (EN)',
    internationalizationVariables: 'Internationalization',
    menuIcon: 'Menu Icon',
    componentName: 'Component Name',
    menuLevel: 'Menu Level',
    firstLevel: 'First Level',
    secondLevel: 'Second Level',
    thirdLevel: 'Third Level',
    level: 'Level',
    DisplayOrNot: 'Display Or Not',
    sort: 'Sort',
    superiorMenu: 'Superior Menu',
    menuType: 'Menu Type',
    show: 'Show',
    hide: 'Hide',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    addUser: 'Add User',
    editUser: 'Edit User',
    assigningRoles: 'Assigning Roles',
    selectRoles: 'Select Roles',
    usernameAlreadyExists: 'Username already exists.',
    authWay: 'Verification',
    byEmail: 'Email',
    byPhone: 'Phone',
    code: 'Code',
    cancellationStatus: 'Cancellation Status',
    cancelled: 'Close Account',
    active: 'Active',
    webBannerTitle: 'E-commerce Homepage Carousel Settings',
    commodityZoneTitle: 'Commodity Zone',
    commodityZoneAddTitle: 'Add Commodity Zone',
    commodityZoneEditTitle: 'Edit Commodity Zone',
    commodityZoneBasicInfo: 'Zone Basic Information',
    commodityZoneName: 'Zone Name (CN)',
    commodityZoneNameEn: 'Zone Name (EN)',
    commodityZoneSubheading: 'Zone Description (CN)',
    commodityZoneSubheadingEn: 'Zone Description (EN)',
    commodityZoneSortOrder: 'Display Order',
    commodityZoneRelatedProducts: 'Related Products',
    commodityZoneSelectedProducts: 'Selected Products',
    commodityZoneSave: 'Create Zone',
    commodityZoneUpdate: 'Save Changes',
    commodityZoneBackToList: 'Back to List',
    deletecommodity: 'Delete Commodity Zone',
    confirmDeletecommodity: 'Are you sure you want to delete this commodity zone?',
    commodityZoneSelectProductRequired: 'Please select at least one related product',
    commodityZoneLoadFailed: 'Unable to find the selected commodity zone',
    commodityZoneSize:'The number of selected products can only be 1 or 4',
    commodityZoneProfit:'Profit',
    commodityZoneStock:'Stock',
    webBanner: 'Web Banner',
    mobileBanner: 'Mobile Banner',
    ChineseVersion: 'Chinese Version',
    EnglishVersion: 'English Version',
    addBanner: "Add Banner",
    editBanner: "Edit Banner",
    version: "Version",
    position: "Position",
    top: "Top",
    bottom: "Bottom",
    bannerImg: "Banner Image",
    labelText: "Label Text",
    titleText: "Title Text",
    contentText: "Content Text",
    buttonLink: "Button Link",
    buttonText: "Button Text",
    buttonBgColor: "Button Background Color",
    buttonTextColor: "Button Text Color",
    themeBgColor: "Theme Background Color",
    themeColor: "Theme Color",
    bannerBasicSettings: 'Basic Settings',
    bannerImageContent: 'Image and Copy',
    bannerButtonSettings: 'Button Settings',
    bannerThemeStyle: 'Theme Style',
    clickUploadBanner: 'Click to upload an image',
    bannerUploadTip: 'Supports JPG, PNG, and BMP files up to 10MB',
    bannerStylePreview: 'Style Preview',
    bannerRequiredTip: 'Fields marked with * are required',
    deleteBanner: "Delete Banner",
    confirmDeleteBanner: "Are you sure to delete the Banner?",
    emailTaken: 'This email is already registered.',
    phoneTaken: 'This  phone number is already registered.',
    userNameLimit: 'Only letters, numbers, and underscores are allowed. Please avoid using offensive or inappropriate terms',
    userNameLimit2: 'Usernames cannot contain the sensitive word "HURIX"',
    userNameLimit3: 'Please enter a username between 6 and 20 characters',
    passwordLimit: 'Please use at least three types of characters from the following: uppercase letters, lowercase letters, numbers, and special characters. Special characters include!@#$%^&*()_+-=[]{};:,.?~`',
    passwordLimit2: 'Contains a special character that is not allowed',
    identityWithEmail: 'For account security, please verify your identity with the email: 【emailNum】',
    NoEmailFound: 'No user email found',
    AccountClosed: 'Account closed',
    platform: 'Platform',
    buyer: 'Buyer',
    seller: 'Seller',
    system: 'System',
    None: 'None',
    ChangeUsername: 'Change Username',
    auditor: 'Auditor',
    auditTime: 'Audit Time',
  },
  placeholder: {
    input: 'Please Enter',
    select: 'Please Select',
    selectWarehouse: 'Please Select Warehouse',
    height: 'Height',
    width: 'Width',
    length: 'Length',
    inputGoodsKeywords: 'Please Enter Product Name Keywords',
    inputEmailOrPhone: 'Please Enter Email or Phone Number',
    inputOrderNumberOrThirdOrderNumber: 'Enter Order Number or Third Order Number',
    from: "From",
    to: "To",
    minPrice: "Min. price",
    maxPrice: "Max price",
    sellerContact: "Enter owner email / owner phone number",
    buyerContact: "Enter distributor email / distributor phone number",
    recipientContact: "Enter recipient email / recipient phone number",
    salesRepContact: "Enter sales representative email / phone number",
    accountKeyword: "Enter account/email keywords",
    myMoneyTransactionId: 'platform / external transaction ID',
    enterOrderNumber: 'Enter Order Number',
    startDate: 'From',
    endDate: 'To',
    inputWarehouseName: 'Please Enter Warehouse Official Name',
    inputWarehouseEmail: 'Please Enter Warehouse Contact Email',
    productNameKeyword: "Please enter product name keyword",
    merchantSpuKeyword: "Please enter merchant SPU keyword",
    merchantSkuKeyword: "Enter merchant SKU keyword",
    salesRepEmailKeyword: "Please enter sales representative email keyword",
    sellerEmailKeyword: "Please enter seller email keyword",
    shopNameKeyword: "Please enter shop name first two characters",
    shopPageShopNameKeyword: "Enter the first two characters of the shop name",
    productVerifyShopNameKeyword: "Enter the first two characters of the shop name",
    productVerifyProductNameKeyword: "Enter product name keyword",
    customerNameKeyword: "Enter customer name keyword",
    quoteNoKeyword: "Enter quotation number keyword",
    warehouseNameKeyword: "Enter warehouse name keyword",
    trackingNoKeyword: "Enter tracking number",
    returnReasonKeyword: "Enter return reason keyword",
    transactionNoKeyword: "Enter transaction number keyword",
    categoryNameKeyword: "Enter category name keyword",
    brandNameKeyword: "Please enter brand name keyword",
    roleNameKeyword: "Enter role name keyword",
    menuNameKeyword: "Enter menu name keyword",
    inputOrderReturnNo: "Enter Order No. / Return No.",
    inputLogisticsNo: "Enter Return Tracking Number",
    inputShopName: 'Please Enter Shop Name / Email',
    emailKeyword: "Enter sales representative email keyword / seller email keyword",
    buyerEmailKeyword: "Please enter buyer email keyword / distributor email keyword",
    inputSearchKeyword: 'Enter Product Name Keyword/SSIN',
    inputSearchCategoryProductSsin: 'Search Category / Product / SSIN',
    distEmailInput: "Please enter distributor email",
  },
  shop: {
    approved: 'Approved',
    unApproved: 'Unapproved',
    shopName: 'Seller',
    staff: 'Employee Name',
    subAccountList: 'Sub-account',
    subAccountDrawerSubtitle: 'View sub-accounts, statuses, and creation details for the current seller account',
    subAccountListTitle: 'Sub-account List',
    subAccountTotal: 'Total Sub-accounts',
    subAccountEnabled: 'Enabled',
    subAccountDisabled: 'Disabled',
    subAccountRecordCount: '{count} sub-account records',
    editChargeItem: 'Edit charge item',
    logo: 'Logo',
    companyInfo: 'Company Information',
    companyName: 'Company Name',
    registrationNo: 'Registration No.',
    eoriNo: 'EORI',
    vatNo: 'VAT',
    contactPerson: 'Contact Person',
    SellerInfo: 'Seller Information',
    enterResult: 'Review result',
    userName: 'User Name',
    viewImage: 'View Image',
    applicant: 'Applicant',
    applicationTime: 'Application Time',
    certificateFiles: 'Certificate',
    certificateFilesWarning: 'Company registration file, VAT certificate or EORI import and export tax number material',
    certificateFilesWarningCnEnterprise: 'company registration documents or VAT certificate materials',
    certificateFilesWarningCnIndividual: 'materials containing the operator\'s handwritten signature and corresponding ID number',
    certificateFilesWarningUkEnterprise: 'company registration number, VAT number, or UK EOR import/export tax number materials',
    certificateFilesWarningUkIndividual: 'registration number and VAT number materials',
    withdrawalContractInfo: 'Contract Information',
    hurixShipperServiceContract: 'HURIX Shipper Service Contract',
    withdrawalContract: 'Contract',
    downloadContractTemplate: 'Contract Template',
    downloadContractTemplateBtn: 'Download HURIX Shipper Service Contract Template',
    withdrawalContractTemplateName: 'Withdrawal Contract Template',
    auditPrompt: 'Audit Prompt',
    auditPrompt1: 'Materials submitted by individual merchants must include the operator\'s personal signature and corresponding ID number;',
    auditPrompt2: 'All qualification documents of enterprise merchants must be stamped with a valid official seal;',
    auditPrompt3: 'The company name, registration number, VAT number filled in the HURIX shipper service contract must be exactly the same as the uploaded enterprise/individual qualification document information;',
    auditPrompt4: 'If there is any mismatch of information, no official seal on enterprise documents, or lack of signature or ID number on individual materials, the entry application will be directly rejected.',
    Attachment: 'Attachment',
    ShipperAccountStatus: 'Seller Account Status',
  },
  message: {
    addedSuccessfully: 'Successfully Added!',
    deleteSucceeded: 'Successfully Deleted!',
    uploadFailed: 'Upload Failed!',
    sendCode: 'The verification code has been successfully sent!',
    operateSuccess: 'Operated Successfully!',
    parameterError: 'Parameter error!',
    loginSuccess: 'Login Successfully!',
    operateFailed: 'Operate Failed!',
    systemError: 'System Error！Please contact administrator',
    information: 'Information',
    deleteInformation: 'Are you sure you want to delete this data?',
    deleteSelectedInformation: 'Are you sure you want to delete the selected data?',
    confirmInformation: 'Do you want to confirm the submission?',
    confirm: 'Confirm',
    modifyStatus: 'Are you sure you want to modify this status?',
    duplicatePhoneNumber: 'Duplicate Phone Number.',
    phoneRequired: 'Phone number is required.',
    emailRequired: 'Email address is required.',
    WhetherTo: 'Whether to',
    classification: 'classification',
    FileUploadFailure: 'File upload failure',
    fileFormatIncorrect: 'The uploaded file format is incorrect',
    exceedTenM: 'The file size cannot exceed 10M!',
    fileTypeMustBeJPGOrPng: 'The file type must be JPG or PNG or BMP!',
    copySuccessfully: 'Successfully Copied!',
    supportedMediaFormats: "Only images and videos in m4v, mp4, mkv, mov, 3gp, webm formats are supported for upload!",
    pleaseSelectShelf: 'Please select the shop to settle!',
    uploadSuccessfully: 'Successfully Upload',
    noticeTitle: "Alert",
    goodsShippedTip: "Goods have been dispatched/shipped. Please double-check whether the approval is passed.",
    orderCancelTip: "The system will cancel the HURIX order and process automatic refund. Please notify the warehouse as soon as possible to intercept the shipment.",
    hasUnverifiedOrdersTip: 'There are unverified orders. Please verify them and try again.',
    enterCode: 'Please Enter Code',
    resetPwdTip: 'Already have an account ?',
    signUpNow: 'Sign In',
  },
  rulesTips: {
    required: 'This field is required.',
    emailTips: 'Please enter a valid email address.',
    correctPhoneEmailNumber: 'Please enter a valid mobile phone number or email address',
    enterChar: 'Enter 3 or more characters.',
    enterPasswordAgain: 'Please enter your password again',
    passwordInconsistent: 'The two passwords are inconsistent!',
    noSpace: 'Cannot include spaces',
    passwordLength: 'Length must be between 8 and 20 characters',
    passwordComplexity: 'Must contain at least 3 of the following: uppercase letters, lowercase letters, numbers, and symbols',
    max35Characters: 'The content cannot exceed 35 characters.',
    twoToOneHundredAndForty: 'Please enter 2-140 characters.',
    requiredFields: 'Required fields cannot be empty!',
    loginAgain: 'This operation will force you to log out, and log back in to the system!',
    enterMore: 'Please enter at least two characters.',
    postcodeTip: 'Invalid UK postcode format. Example: SW1A 1AA',
    correctPhoneNumber: 'Please enter the correct mobile phone number format',
    emailNotRegistered: 'This email is not registered',
    phoneNumberNotRegistered: 'This phone number is not registered',
    fileSizeLess10: 'The file size must be less than 10MB.',
    changeTime: 'Change Time',
    previousStatus: 'Previous Status',
    currentStatus: 'Status',
    withdrawStatusCollection: 'Withdrawal Progress',
    withdrawStatus: 'Withdrawal Status',
    withdrawFailReason: 'Reason for Withdrawal Failure',
    withdrawStatus1: 'Withdrawal Application Pending',
    withdrawStatus2: 'Balance Recharging',
    withdrawStatus3: 'Settlement Under Review',
    withdrawStatus4: 'Withdrawing',
    withdrawStatus5: 'Withdrawal Successful',
    withdrawStatus6: 'Withdrawal Failed',
    refundAmount: 'Please enter refund amount'
  },
  home: {
    index: 'Ranking',
    dashboardTitle: 'Real-time Business Monitoring · Data-driven Decisions',
    lastUpdateTime: 'Last update',
    report: 'Report',
    loading: 'Loading...',
    operationalPending: 'Operational Pending',
    financePending: 'Finance Pending',
    buyerBalanceApply: 'Buyer balance requests',
    sellerBalanceApply: 'Seller balance requests',
    orderTradeTrend: 'Order Volume Trend',
    gmvTrend: 'GMV Trend',
    userRegisterTrend: 'User Registration Trend',
    paymentChannelShare: 'Payment Channel Share',
    alipayPay: 'Alipay payment',
    wechatPay: 'WeChat payment',
    bankCardPay: 'Bank card payment',
    tooltipPendingShelf: 'Pending seller onboarding applications',
    tooltipPendingProduct: 'Pending product SPU reviews',
    tooltipPendingWarehouse: 'Pending warehouse onboarding applications',
    tooltipPlatformIntervention: 'Orders with platform intervention in after-sales disputes',
    tooltipOutstandingPaymentSettlement: 'Outstanding debt past the settlement cycle',
    tooltipEstimatedSettlement: 'Estimated amount to be settled in the next cycles',
    tooltipBuyerBalanceApply: 'Withdrawals, repurchase refunds, pre-order releases, deposit refunds, expiry refunds',
    tooltipSellerBalanceApply: 'Withdrawals, platform settlement',
    seriesRealtimeOrder: 'Realtime orders',
    seriesPreOrder: 'Pre-orders',
    seriesDistributorChannel: 'Distributor channel orders',
    seriesNgtChannel: 'NGT channel orders',
    seriesRealtimeGmv: 'Realtime GMV',
    seriesPreGmv: 'Pre-order GMV',
    seriesDistributorGmv: 'Internal Order GMV',
    legendNgtChannelGmv: 'Non-internal Order GMV',
    seriesNgtGmv: 'NGT GMV',
    legendRealtime: 'Realtime',
    legendPreOrder: 'Pre-order',
    legendDistributorChannel: 'Distributor channel',
    legendNgtChannel: 'Non-internal order',
    shipperTotal: 'Seller total',
    distributorTotal: 'Distributor total',
    spuCategory: 'SPU categories',
    lowStockSku: 'Low-stock SPU',
    statisticsDetailTitle: 'Statistics Details',
    statisticsDetailSubTitle: 'Multi-dimensional business dashboard monitors orders, GMV, user growth, payment composition and sales performance to empower your operation and decision-making.',
    dateRangeSep: '~',
    query: 'Query',
    export: 'Export',
    querySuccess: 'Query succeeded',
    exportSuccess: 'Exported current table successfully!',
    colDate: 'Date',
    colTotal: 'Total',
    colShipperRegister: 'Seller sign-ups',
    colDistributorRegister: 'Distributor sign-ups',
    colPeriod: 'Period',
    colAlipay: 'Alipay',
    colWechat: 'WeChat',
    colBankCard: 'Bank card',
    colAlipayRate: 'Alipay share',
    colWechatRate: 'WeChat share',
    colBankCardRate: 'Bank card share',
    colShipperOnboard: 'Seller onboarded',
    colShipperOrderAmountMonthly: 'Daily order amount (Seller)',
    colDistributorOnboard: 'Distributor onboarded',
    colDistributorOrderAmountMonthly: 'Daily order amount (distributor)',
    pendingShelf: 'Unaudited Seller',
    pendingProduct: 'Unaudited Products',
    pendingOrder: 'Unaudited Order',
    pendingWarehouse: 'Unaudited Warehouse',
    orderReview: 'Order Overview',
    orderSum: 'Order Count',
    settleOrderSum: 'Settled Orders Count',
    OrderReceived: 'Pending Delivery',
    pendingPaymentOrder: 'Pending Payment',
    pendingDeliveryOrder: 'Pending Shipment',
    shippedOrders: 'Shipped Orders',
    completedOrder: 'Completed Orders',
    productReview: 'Product Overview',
    allProducts: 'Product quantity',
    listing: 'Listed',
    delisting: 'Delisted',
    inventoryShortage: 'Low Inventory',
    quickEntrance: 'Quick Access',
    backOrder: 'Back Order',
    pendingShipmentOrder: 'Pending Shipment Orders',
    commodityInventory: 'Inventory below 10',
    inventoryAlert: 'Inventory Alert',
    orderInformation: 'Order Detail',
    quantityOfGoods: 'Quantity of Goods',
    remainingInventory: 'Remaining Inventory',
    settlementAmount: 'Historical Earnings',
    "newbieTask": "Newbie Task: Publish a Product",
    title: 'Congratulations on completing the new store registration. To better enjoy the sales benefits of  HURIX, please publish your products as soon as possible.',
    checkTutorial: 'Check the tutorial',
    "publishNow": "Publish Now",
    "newlyAddedProduct": "Newly added product",
    "priceDeclaration": "Price declaration",
    "officialSale": "Official sale",
    "deliverToConsumers": "Deliver to consumers",
    "returnReview": "Return Review",
    "pendingAfterSales": "Pending After-sales",
    cancelOrderPending: 'Cancel order pending processing',
    "logisticsException": "Logistics Exception",
    "pendingViolation": "Pending Violation",
    "operatingData": "Operating Data",
    "realTime": "Real-time",
    "last7Days": "Last 7 Days",
    "last30Days": "Last 30 Days",
    moreData: 'More Data',
    "transactionAmount": "Transaction Amount",
    "transactionVolume": "Transaction Volume",
    "numberOfCustomers": "Number of Customers",
    "productVisitors": "Product Visitors",
    "productClicks": "Product Clicks",
    "refundOrders": "Refund Orders",
    "storeExpenditure": "Store Expenditure",
    "withdrawAmount": "Withdrawable Amount",
    "yesterday": "Yesterday",
    withdraw: 'Withdraw',
    "flat": "Flat",
    registerTrend: "Seller and Buyer Registration Trends (30 Days)",
    "realTimeOrderAmount": "Real-time Order Transaction Amount",
    "realTimeOrderVolume": "Real-time Order Transaction Volume",
    "realTimeOrderCustomers": "Real-time Order Transaction Customers",
    "reservationOrderAmount": "Reservation Order Transaction Amount",
    "reservationOrderVolume": "Reservation Order Transaction Volume",
    "reservationOrderCustomers": "Reservation Order Transaction Customers",
    estimated: "Estimated amount pending settlement",
    productsExpiringSoon: "Products Expiring Soon",
    outstandingPaymentSettlement: "Settle outstanding balance",
  lowRatedProductsCount: "Low Rated Products Count",
  unconfirmedReceipts: "Unconfirmed Receipts",
  productsOnHold: "Products On Hold",
  afterSalesPending: "Under after-sales review",
  alipayOrderVolume: "Alipay Order Volume",
  wechatOrderVolume: "WeChat Order Volume",
  bankcardOrderVolume: "Bankcard Order Volume",
  salesRepData: "Sales Rep Referral Data Statistics",
  statisticalPeriod: "Statistical Period:",
  priceDistribution: 'Order Amount Distribution',
  peopleDistribution: 'People Distribution',
  leftSemicircle: 'L-Semi',
  rightSemicircle: 'R-Semi',
  distributor: 'Distributor',
  shipper: 'Seller',
  detailedData: 'Detailed Data',
  supportsMultipleLines: 'Supports multiple lines',
  failedToGetPeoplePieData: 'Failed to get recommended total people pie chart data',
  failedToGetPricePieData: 'Failed to get exclusive link statistics pie chart data',
  distributorOrderTotal: 'Distributor Order Total',
  shipperOrderTotal: 'Seller Order Total',
  salesRepresentative: 'Sales Representative',
  salesPerformance: 'Sales Performance',
  numberOfReferrals: 'Number of Referrals',
  clickToViewDetails: 'Click to view details',
  people: 'people'
  },
  product: {
    physicalGoods: 'Physical Goods',
    importProductTemplate: 'Import Product Template',
    retailInfo: 'Retail and wholesale, logistics and distribution',
    templateInfo: 'Product template, one click import',
    selectProductType: 'Please select the product type',
    basicInfo: 'Basic information',
    commodityTradingInfo: 'Product Trading Information',
    productSpecification: 'Product specifications and images',
    productDesc: 'Product Details',
    productLogisticsInfo: 'Product logistics information',
    otherInfo: 'Other information',
    category: 'Category',
    price: 'HURIX selling price',
    weight: 'Product Weight',
    dimensions: 'Product size',
    quantity: 'Quantity',
    referencePrice: 'Market Reference Price(VAT included)',
    referenceLink: 'Reference Link',
    profit: 'Discount Rate(Relative to Market Reference Price)',
    productName: 'Product Name',
    listingStatus: 'Listing Status',
    productImage: 'Product Image',
    stock: 'Stock',
    productStock: 'Product Stock',
    verifyStatus: 'Approval Status',
    pendingApproval: 'Pending Approval',
    reviewRejected: 'Rejected',
    selectProductCategory: 'Select Product Category',
    fillInProductDetails: 'Fill in Product Details',
    products: 'Products',
    TotalProductPrice: 'Total Product Price',
    total: 'Total',
    productReleaseSuccessful: 'Product Release Successful',
    publishedSuccessfullyMsg: 'Congratulations, the product has been successfully released!',
    viewProductStatus: 'Go check the product review status',
    youCanAlso: 'You can also',
    goOn: 'Go on',
    publishProduct: 'Publish Product',
    productPrice: 'Product Price',
    sellingPoint: 'Selling Point',
    productBrand: 'Product Brand',
    brandName: 'Brand Name',
    brandIcon: 'Brand Icon',
    unit: 'Sales Unit',
    hostGraph: 'Main Product Image',
    uploadFile: 'Upload File',
    fileToWithin10MB: 'Please compress the file to within 10MB',
    customSpecificationItems: 'Custom specification items',
    addSpecificationItems: 'Add Specification Items',
    specificationItem: 'Specification Item',
    addSpecificationImages: 'Add Specification Images',
    specificationValue: 'Specification Value',
    specificationName: 'Specification Name',
    detailedSpecifications: 'Detailed Specifications',
    verifyMaterials: 'Verification Materials',
    productInfoVerifyTip: 'Please provide inventory proof materials to ensure the authenticity and availability of product information.',
    previousStep: 'Previous Step',
    saveProduct: 'Save Product',
    saveDraft: 'Save Draft',
    reason: 'Reason',
    pass: 'Pass',
    refuse: 'Reject',
    editInventory: 'Edit Inventory',
    editProductInformation: 'Edit Product Information',
    skuNumber: 'SKU Number',
    sellingPrice: 'Selling Price',
    selling: 'Selling',
    soldOut: 'Sold Out',
    addBrand: 'Add Brand',
    reasonForRejection: 'Reason for Rejection',
    brandLogo: 'Brand Logo',
    classificationName: 'Classification Name',
    editCategory: 'Edit Category',
    addCategory: 'Add Category',
    defaultIcon: 'Default icon',
    selectIcon: 'Select icon',
    categoryParent: 'Parent Category',
    categoryDrawerTip: 'Use the same form to add, edit, or create a subcategory',
    categoryInfo: 'Category Information',
    categoryInfoTip: 'Maintain category names and hierarchy',
    categoryIconConfig: 'Category Icons',
    categoryIconTip: 'Configure the default and selected-state icons',
    categoryRequiredTip: 'Fields marked with * are required',
    expirationDate: 'Expiration Date',
    localTimeAtWarehouse: 'Local Time at Warehouse Location',
    bindWarehouse: 'Bind Warehouse',
    addAndBindWarehouse: 'Add Warehouse',
    businessType: 'Business Type',
    warehouseInfo: 'Managed Inventory',
    list: 'List',
    delist: 'Delist',
    notFindBrand: 'No related brands found? Add a brand now.',
    enterYourReviewResult: 'Review result',
    productCommissionByThePlatform: 'Platform Commission Rate',
    spu: 'Seller SPU',
    shipperSku: 'Seller SKU',
    supportFiveFiles: 'Supports uploading up to 5 files',
    isAutoList: 'Listed after approval',
    canBeReturned: 'Buyer returns',
    carrier: 'Carrier',
    transitTime: 'Transit Time',
    weightLimit: 'Weight Limit',
    basicFreight: 'Base Rate',
    surcharge: 'Surcharges',
    auditReminder: 'Product has warehouses pending review. Please complete approval first. ',
    WarehouseAddress: 'Warehouse Address',
    isSplit: 'Split Allowed (≤30kg)',
    AvailableStock: 'Available Stock',
    ConfirmTakeOffline: 'Confirm to take offline \n',
    "documentProofs": "Document Proofs",
    "customsDeclaration": "Customs Declaration",
    "purchaseInvoice": "Purchase Invoice",
    "warehouseEntryVoucher": "Warehouse Receipt",
    "certificateOfGoods": "Entrusted Goods Proof",
    "brandAuthorizationLetter": "Brand Authorization",
    taskName: 'Task Name',
    taskStatus: 'Task Status',
    taskResultDescription: 'Task Result Description',
    uploading: 'Parsing',
    parsingSuccessful: 'Parsing successful',
    parsingFailed: 'Parsing failed',
    partiallySuccessful: 'Partially successful',
    shipping: 'Shipping',
    isShippingFree: 'Is shipping free',
    packageWeight: 'Package weight',
    packageDimensions: 'Package dimensions',
    estimatedShippingCost: 'Estimated shipping cost',
    shippingNotes: 'Mainland areas include England, Wales, and Scotland, while remote areas refer to Northern Ireland and the Scottish Highlands. When calculating seller categories, we consider both collection and delivery volumes; however, delivery parcels will always be charged according to the delivery rate schedule.',
    remoteAreas: 'Remote areas include the following regions:',
    consigneeInformation: 'Consignee/Seller Information',
    settlementTask: 'Settlement Task',
    reconciliationTask: 'Reconciliation Task',
    taskList: 'Task List',
    taskRecords: 'Task Records',
    taskTotal: 'Total Tasks',
    successfulTasks: 'Parsed Successfully',
    pageSuccess: 'Page Success',
    pageFail: 'Page Fail',
    failedTasks: 'Failed Tasks',
    taskRecordCount: '{count} task records',
    settlementTaskSubtitle: 'View the status and parsing results of recent batch settlement tasks',
    reconciliationTaskSubtitle: 'View the status and parsing results of recent batch reconciliation tasks',
    batchSettlement: 'Batch Order Settlement',
    batchReconciliation: 'Batch Reconciliation',
    viewSettlementTask: 'View Settlement Task',
    viewReconciliationTask: 'View Reconciliation Task',
    tradeLegalityDesc: 'Imported goods (must include commodity code, customs clearance date, seller name, tax payment status, etc.)',
    originAuthenticityDesc: 'Purchased goods (must include VAT number, purchaser consistent with seller)',
    inventoryExistenceDesc: 'Third-party overseas warehouse hosted goods (must show storage time, SKU code, seller name)',
    goodsAuthenticityDesc: 'Official contact information of the issuing warehouse, certificate number, and goods details',
    ipComplianceDesc: 'Agent/distribution brand goods (must have brand owner seal and authorization validity period)',
    isReturnableTips: 'Set whether the product supports returns, which affects buyers\' purchase decisions',
    estimatedShippingCostTips: 'Estimated shipping cost tips',
    packageDimensionsTips: 'Package dimensions refer to the length, width, and height of the packaged product, which affects shipping cost calculation and transportation method selection',
    packageWeightTips: 'Package weight refers to the total weight of the packaged product, which affects shipping cost calculation',
    isSplitTips: 'Whether to support splitting the product into multiple packages for shipping, suitable for large items',
    autoShelvesTips: 'Whether to automatically list the product after approval, saving operation time',
    detailsTips: 'Product details are important content to show buyers the features and advantages of the product, so it is recommended to fill them in detail',
    fillInSpec: 'Fill in spec',
    fillInSpecTips: 'Specification items are basic attributes of the product, such as color, size, etc., used to distinguish different SKUs.<br>Specification values are specific contents of specification items, such as red, blue, M size, L size, etc.',
    hostGraphTips: 'Aspect ratio: 1:1. File size limit: 10 MB. Format: JPG/PNG/GIF. Size: 800×800px',
    spuTips: 'SPU is a unified product identifier. It is recommended to fill in the merchant\'s internal product code for unified product management, inventory tracking, and multi-specification product classification.',
    dimensionsTips: 'Fill in the actual dimensions of the product, including length, width, and height, in centimeters (cm). Ensure the dimension information is accurate to avoid logistics issues',
    weightTips: 'Fill in the actual weight of the product. The unit can be grams (g) or kilograms (kg). Ensure the weight information is accurate to avoid logistics issues',
    brandTips: 'Fill in the brand name of the product. Ensure the brand information is accurate, which helps establish brand image and improve product credibility',
    categoryTips: 'Select the correct product category, which helps buyers find your product quickly and improves exposure and conversion rate',
    sellingPointTips: 'Highlight the core advantages and unique selling points of the product to attract buyers\' attention and promote conversion, no more than 500 characters',
    productNameTips: 'Clearly and accurately describe the product, including core attributes and features, using concise and clear language, no more than 255 characters',
    documentProofsTip: 'Sellers must provide at least one of the above document proofs. Maximum 5 files per item, single file ≤10M',
    specTips: 'At least one specification item is required. Each specification item must have at least one specification value. Each specification value under the first specification item must upload a corresponding image. A maximum of five specification items are supported.',
    recommendedCategories: 'Recommended categories',
    selectCategory: 'Select category',
    basicInfoTips: 'Fill in the basic information of the product, including core attributes such as name, selling points, category, brand, weight, and dimensions. Ensure the information is accurate and complete to help with product exposure and conversion.',
    Reservation: 'Reservation',
    buyNow: 'Buy now',
    cumulativeEvaluation: 'Cumulative evaluation',
    profitable: 'Profitable',
    imageCropping: 'Image cropping',
    inventoryAdjustmentWarning: 'Inventory adjustment warning',
    warehouseNameTips: 'Warehouse name tips',
    referenceLinkTips: 'Reference link tips',
    requiredToProvideMarketPrice: 'Required to provide market price',
    supplyPrice: 'Supply Price',
    supplyPriceExplain: 'Full-service contract signing price',
    platformPriceExplain: 'Platform price explanation',
    priceAndStock: 'Price and stock',
    createValue: 'Create value',
    noOption: 'No option',
    createType: 'Create type',
    linkOtherWarehouse: 'Link other warehouse',
    noWarehouseFound: 'No warehouse found',
    auditSection: 'Audit Operation',
    auditResult: 'Audit Result',
    auditMessage: 'Audit Comments',
    approve: 'Approve',
    reject: 'Reject',
    submitAudit: 'Submit Audit',
    rejectMessageRequired: 'Please enter rejection reason',
    auditMessagePlaceholder: 'Please enter audit comments (optional)',
    quickBooksAuthorization: 'QuickBooks Authorization',
    productDetailTitleMod: 'Bolded text indicates changes, ',
    productDetailTitleDel: 'crossed-out text indicates deletions',
    productDetailTitleDelComma: ', ',
    productDetailTitleVerify: 'Please verify all modifications.',
    sameCategoryDetect: "Category with identical name detected",
    pendingCategoryInfo: "Category information to be submitted",
    fullCnPath: "Full Chinese Path",
    fullEnPath: "Full English Path",
    existSameCategoryTip: "The following category with the same name already exists in the system",
    tipSameCategory: "Notice: A category with the same name already exists in the system. You may still create it by clicking Confirm Add.",
    backEditBtn: "Back to Edit",
    confirmAddBtn: "Confirm Add",
    autoApproveProduct: 'Enable automatic product approval',
    productReviewSettings: 'Product Review Settings',
    pendingApprovalDesc: 'System approval will update the product status automatically',
    productVat: "VAT on Product",
    shippingVat: "VAT on Shipping",
  },
  order: {
    order: 'Order',
    orderSn: 'Order Number',
    orderNumber: 'Order Number',
    buyerContact: "Buyer's email / phone",
    buyerName: 'Buyer',
    buyer: 'Buyer',
    seller: 'Seller',
    consignee: 'Consignee',
    orderTime: 'Order Date',
    orderStatus: 'Order Status',
    startDate: 'Start Date',
    endDate: 'End Date',
    orderAmount: 'Order Amount',
    paymentMethod: 'Payment Method',
    viewOrder: 'View Order',
    PendingPayment: 'Awaiting Payment',
    toBeConfirmed: 'To Be Confirmed',
    pendingShipment: 'Ready to Ship',
    partialShipment: 'Partially Shipped',
    inTransit: 'In Transit',
    shipped: 'Shipped',
    ReservationInProgress: 'Pre-Order in Progress',
    PreOrderInProgress: 'Pre-Orders in Progress',
    completed: 'Completed',
    OrderCompleted: 'Completed',
    closed: 'Closed',
    OrderClosed: 'Closed',
    Cancelled: 'Cancelled',
    alipay: 'Alipay',
    wechat: 'WeChat',
    unpaid: 'Unpaid', // 修正首字母
    orderLog: 'Order History',
    cancellationOfOrder: 'Order Cancellation', // 优化语序
    CancellationReason: 'Cancellation Reason',
    addANote: 'Add Note', // 去除冗余冠词
    country: 'Country',
    city: 'City', // 修正首字母
    logisticsInformation: 'Shipping Information',
    orderDetails: 'Order Details',
    syncLogistics: 'Sync Logistics',
    noSyncLogisticsToThirdParty: 'No Sync Logistics to Third Party',
    receiptInformation: 'Ship To',
    orderNotes: 'Order Notes', // "Remarks" → "Notes" 统一术语
    invoiceInformation: 'Invoice Information',
    noInvoiceInformation: 'Invoice details not provided',
    specifications: 'Specifications',
    number: 'Quantity', // "Number" → "Quantity" 更准确
    subtotal: 'Subtotal',
    totalAmount: 'Item Total',
    recipient: 'Recipient',
    recipientRegion: 'Recipient Region',
    detailedAddress: 'Detailed Address',
    postcode: 'Postcode',
    logisticsCompany: 'Carrier',
    logisticsStatus: 'Logistics Status',
    trackingNumber: 'Shipment Number',
    deliveryTime: 'Delivery Time',
    shipmentQuantity: 'Shipment Quantity',
    noLogisticsInformation: 'No logistics information',
    shippingAddress: 'Shipping Address',
    platformHandlingFee: 'Platform Commission Fee',
    ReservationInformation: 'Pre-order Information',
    ReservationPeriod: 'Pre-order Period',
    priceModel: 'Price Model',
    NumberOfReservations: 'Pre-order Quantity', // 小写 "of"
    confirmModifyRemarksOrder: 'Are you sure you want to modify the order remarks', // 优化语序
    sureCancelOrder: 'Are you sure you want to cancel this order? Please provide the reason.', // 优化提示
    realTimeOrder: 'Real-time Orders', // 增加连字符
    ReservationOrder: 'Pre-Orders',
    lockPriceModel: 'Lock Price Model', // 术语优化
    noLockPriceModel: 'Non-lock Price Model',
    days: 'Days',
    proportionOfDeposit: 'Deposit Percentage', // 修正术语
    amountOfDeduction: 'Deduction of amount',
    deposit: 'Deposit', // 首字母大写
    NotYetCreated: 'Not Yet Created',
    AwaitingReceipt: 'Out for Delivery', // 更自然表达
    waitBuyerShip: "Awaiting Buyer Shipment",
    waitSellerReceive: "Awaiting Seller Receipt",
    ReservationCompleted: 'Pre-order Completed',
    PreOrderCompleted: 'Pre-Orders Completed',
    RemainingReservableQuantity: 'Remaining Pre-orderable Quantity',
    PolicyNumber: 'Policy Number',
    InsuranceCompany: 'Insurance Company',
    PolicyStatus: 'Policy Status',
    AmountInsurance: 'Insurance Premium Amount',
    AmountCompensation: 'Compensation Amount',
    InEffect: 'In Effect',
    failure: 'lose efficacy', // 状态一致性
    undo: 'Undo',
    ClaimsProgress: 'Claim in Progress', // 修正动词形式
    CompensationComplete: 'Compensation Completed', // 时态一致性
    Terminate: 'Terminated', // 状态一致性
    Frozen: 'Frozen',
    state: 'State/Province',
    InRefund: 'In Refund', // 更自然状态名
    RefundSuspension: 'Refund Suspended',
    RefundSuccessful: 'Refund Succeeded', // 动词形式优化
    RefundFailure: 'Refund Failed',
    InRefundLog: 'Your refund is being processed. Please wait patiently.', // 优化语句
    RefundSuspensionLog: 'Refund suspended due to insufficient account balance.',
    RefundCompletedLog: 'Your refund has been processed successfully.',
    RefundFailureLog: 'Your refund request has failed.',
    insufficientStockReservation: 'Your pre-order has been canceled and a refund will be issued due to insufficient stock of the item',
    refund: 'Refund',
    created: 'Created',
    enterReasonRefund: 'Please enter the refund reason',
    createdLog: 'Your order has been created',
    toBeConfirmedLog: 'Your order has been submitted.We‘re now processing it - please wait a moment.',
    PendingPaymentLog: 'Order confirmed,Pending payment',
    pendingShipmentLog: 'We have received your payment and the product is being prepared for shipment.',
    partialShipmentLog: 'Part of your order has been shipped. The remaining items will be dispatched as soon as possible',
    InTransitLog: 'All items have been dispatched and are currently in transit',
    WaitToBeReceivedLog: 'Your package has arrived at the destination,Please collect it promptly',
    completedLog: 'Order completed. Thank you for your purchase',
    ReservationInProgressLog: 'Pre-Order In Progress(Awaiting Fulfillment)',
    ReservationCompletedLog: 'All pre-ordered products have been purchased, and the pre-order is now closed',
    closedLog: 'Payment timeout, the system cancels the order',
    CancelledLog: 'Your order has been canceled',
    RefundLog: 'Refund History',
    RefundAmount: 'Refund Amount',
    TotalRefundAmount: 'Total Refund Amount',
    RefundStatus: 'Refund Status',
    ReservationDeductionAmount: 'Pre-order Deduction',
    BuyerPaid: 'Paid by Buyer',
    PlatformRevenue: 'Platform Income After Transaction', // 简化术语
    commodityInformation: 'Product Information', // 术语统一
    InitiatePurchase: 'Initiate Purchase', // 更自然表达
    cancelPurchase: 'Cancel Purchase',
    CommodityQuantity: 'Product Quantity', // 术语统一
    paymentId: 'Payment Transaction ID', // 简化术语
    level: 'Level',
    ReturnRequestNo: 'Return Request #',
    ReturnLog: 'Return History',
    createdReturn: 'Return request has been successfully created',
    toBeConfirmedReturn: 'Return request has been successfully submitted and is being processed',
    pendingShipmentReturn: 'Return Approved - Please Ship Items & Submit Tracking Info',
    inTransitReturn: 'Returned items have been shipped and are in transit',
    AwaitingReceiptReturn: 'Returned items have arrived at destination address',
    completedReturn: 'Return process completed - refund initiated',
    reviewRejectedReturn: 'Return request closed (seller declined)',
    CancelledReturn: 'The return application has been cancelled and the return process is closed',
    returnInformation: 'Return Information',
    returnReason: 'Return Reason',
    addReturnReason: 'Add Return Reason',
    editReturnReason: 'Edit Return Reason',
    returnVerificationPhotos: 'Return Verification Photos',
    returnList: 'Return List',
    returnStatus: 'Return Status',
    returnTime: 'Return Time',
    reservationExpired: 'Pre-order expired',
    reservationRefunded: 'Pre-order deposit refunded',
    BreachPenalty: 'Breach Penalty',
    penaltyChargeTip: 'Liquidated damages will be incurred if the pre-order is not completed within the specified period or is cancelled',
    Returned: 'Return Exists',
    returnAddress: 'Return Address',
    returnDetails: 'Return Details',
    breachQuantity: 'Breach Quantity',
    purchasableQuantity: 'Purchasable Quantity',
    refundDetails: 'Refund Details',
    refundReason: 'Refund Reason',
    refundTransaction: 'Refund Transaction ID',
    all: 'All',
    RefundsReturns: 'Return & Refund',
    returnOccurs: 'Return',
    refundHappens: 'Refund Happens',
    purchasableQuantityReduce: 'Insufficient product inventory. Purchasable quantity has been reduced by refundQuantity',
    releaseQuantityRefunded: 'Refund due to insufficient product inventory.Quantity refunded: refundQuantity',
    ReturnId: 'Return Number',
    returnRecords: 'Return Records',
    refundRecords: 'Refund Records',
    shippingParty: 'Delivery Cost Paid By',
    returnShippingParty: 'Return Shipping Party',
    credential: 'Credential',
    afterConfirmingReceipt: 'The corresponding payment will be refunded to the buyer after confirming receipt.',
    negotiationHistory: 'Negotiation History',
    ReturnRequestSubmitted: 'Return Request Submitted',
    ReturnRequestApproved: 'Return Request Approved',
    buyerHasShipped: 'The buyer has shipped the goods',
    ReceiptConfirmedSeller: 'Receipt Confirmed by Seller',
    ReturnRequestRejected: 'Return Request Rejected',
    ReturnRequestCancelled: 'Return Request Cancelled',
    notes: 'Notes',
    RefundType: 'Refund Type',
    RequestPlatformIntervention: 'Request platform intervention',
    PlatformIntervention: 'Platform Intervention',
    PlatformProcessing: 'Platform Processing',
    PlatformAdjustsReturnStatus: 'Platform Adjusts Return Status',
    Arbitration: 'Arbitration',
    ReturnLogisticsPayer: 'Return Logistics Payer',
    UpdateReturnStatus: 'Update return status',
    senderAddress: 'Sender Address',
    arbitrationResult: 'Arbitration Result',
    ShippingLogisticsCostBearer: 'Shipping Logistics Cost Bearer',
    ReturnLogisticsCostBearer: 'Return logistics cost bearer',
    ReturnAndRefundSupported: 'Return and refund supported',
    ReturnsRefundsNotSupported: 'Return and refund are not supported',
    MaximumReservation: 'Maximum Pre-order Period',
    CreditCard: 'Bank Card',
    OrderTotal: 'Order Total',
    orderTotalSubVat: 'Net order amount',
    RefundOnly: 'Refund only',
    PartyLiableShipment: 'Party liable for shipping rate (shipment)',
    PartyLiableReturn: 'Party liable for shipping rate (return)',
    shipmentTotalMoney: 'Total shipping rate (shipment)',
    returnTotalMoney: 'Total shipping rate (return)',
    estimated: 'Estimated',
    refundOnlyTip: 'Refund-only orders support adjustment of the refund amount. Please check carefully before changing it to reduce unnecessary disputes.',
    currentRefundAmount: 'Current Refund Amount',
    defaultFullRefundEditable: 'Full refund by default, editable',
    buyerRefundableTotal: 'Buyer refundable total',
    refundAmountCannotExceed: 'The refund amount cannot exceed the refundable total',
    enterRefundAmount: 'Enter refund amount',
    ReturnLogisticsCompany: 'Return Carrier',
    CardPaymentHandlingFee: 'Payment Handling Fee',
    refundFee: 'Refund Processing Fee',
    refundFeeRule: 'A fixed processing fee of num will be charged per refund transaction.',
    balance: 'Balance',
    ShipFree: 'Free Delivery',
    AllOrders: 'All Orders',
    requiredToShip: '24h required to ship',
    OvertimeShipped: 'Overtime not shipped',
    LogisticsTrackingNumber: 'Logistics Tracking Number',
    LastDay: 'Last 24 hours',
    LastDay7: 'Last 7 days',
    LastDay30: 'Last 30 days',
    LastDay90: 'Last 90 days',
    sellerContact: "Seller's phone/email",
    unitPrice: 'Unit Price',
    AfterSalesStatus: 'After-sales Status',
    None: 'None',
    PromiseShip: 'Confirm shipment in',
    PromiseShip2: '',  // 有用别删
    autoCancelTip: "The order will be automatically cancelled in ",
    autoCancelTip2: ". Please arrange shipment promptly.",
    timedOutStatus: '00:00:00',
    ShippingInformation: 'Shipping Information',
    LogisticsUpdates: 'Logistics Updates',
    BuyerPlacesOrder: 'Buyer Places Order',
    PaymentSuccessful: 'Payment Successful',
    MerchantShipsGoods: 'Merchant Ships Goods',
    TransactionCompleted: 'Transaction Completed',
    orderType: 'Order Type',
    paymentTime: 'payment time',
    BuyerInformation: 'Buyer Information',
    BuyerRemarks: 'Buyer Remarks',
    BuyerNickname: 'Buyer Nickname',
    DeliveryInformation: 'Delivery Information',
    DeliveryMethod: 'Delivery Method',
    LogisticsDelivery: 'Logistics Delivery',
    OtherInformation: 'Other Information',
    PurchaseSource: 'Purchase Source',
    WebVersion: 'Web Version',
    returnWindowCloseAfter: 'Return window closes after',
    InsuranceInformation: 'Insurance Information',
    RequestTime: 'Requested Time',
    cancelHasBeenInitiated: 'A cancellation request for the order has been initiated',
    labelGenerationStatus: 'Courier waybill generation status',
    labelGeneratedSuccess: 'Generated successfully',
    labelGenerating: 'Generating',
    labelGeneratedFailed: 'Generation failed',
    GeneratingLabel: 'Return waybill is being generated',
    returnShippingLabelGenerating: 'Return courier waybill is being generated',
    consigneeEmailOrPhone: 'Consignee Email / Phone',
    thirdPartyOrders: 'Third-Party Orders',
    tiktokOrders: 'TikTok Order',
    temuOrders: 'Temu Order',
    amazonOrders: 'Amazon Order',
    shopifyOrders: 'Shopify Order',
    afterSaleRecordsTip: 'num after-sales records , Click to view',
    hours: 'hours',
    minutes: 'minutes',
    orderOrtThirdParty: 'Please enter the order number or third-party order number.',
    returnHasClosed: 'The return window has closed',
    salesRepresentative: 'Sales Representative',
    confirmReceipt: 'Confirm Receipt',
    isConfirmReceipt: "Confirm receipt of goods?",
    ConfirmReceiptSuccess: 'Confirm Receipt Success',
    arbitrationDescription: 'Please fill in the arbitration result and related information',
    logisticsCostInfo: 'Logistics Cost Information',
    uploadTip: 'Support uploading image formats, up to 5 images, each not exceeding 10MB',
    pushOrderToWarehouse: "Push to Warehouse",
    confirmPushOrderTip: "Confirm to push the order to the warehouse?",
    uploadBill: "Upload Bill",
    settleUploadExcelTip: "Fully managed store settlement requires uploading billing Excel file",
  },
  logistics: {
    shippingCost: 'Shipping & handling',
    deliveryType: 'Delivery Type',
    standardSingleParcel: 'Standard Single Parcel',
    expressSingleParcel: 'Express Single Parcel',
    multipleParcels: 'Multiple Parcels',
    weightLimit: 'Weight Limit',
    perParcel: 'Per Parcel',
    transitTime: 'Transit Time',
    businessDays: 'Business Days',
    BaseShippingCost: 'Base Freight',
    Surcharge: 'Surcharge',
    SeparateRates: 'Separate Rates',
    remoteAreas: 'Remote areas +',
    remoteArea: 'Remote areas',
    MultiParcelFee: 'Multi-Parcel Handling Fee',
    chargeableWeight: 'Chargeable Weight',
    AddressLine1: 'Address Line 1',
    AddressLine2: 'Address Line 2',
    AddressLine: 'Address Line',
    shippingBillingRules: 'Shipping billing rules',
    remoteAreaNoFreeShipping: 'No free shipping to remote areas',
    billingWeightComparisonTable: 'Billing weight comparison table',
    billingWeightComparisonTableRemoteArea: 'Billing weight comparison table (remote areas)',
    isRemoteArea: 'Remote area?',
    yesOption: 'Yes',
    noOption: 'No',
    UKMainland: 'UK mainland',
    UnitedKingdom: 'United Kingdom',
    China: 'China',
    standardRate: "Standard Rate",
    ladderBilling: "Tiered Billing",
    currentBilling: "Current Charge",
    estimatedDeliveryText: "Estimated delivery in 3-7 working days",
    earliestShipTip: "Expected to ship before 24:00 at the earliest",
  },
  template: {
    name: 'Template Name',
    content: 'Template Content',
    siteMessageTemplate: "Site Message Template",
    emailTemplate: "Email Template",
    settlementTemplate: "Settlement Template",
    drawerSubtitle: 'Configure the template information and message content',
    basicInfo: 'Basic Information',
    basicInfoTip: 'Maintain the template code, name, and business type',
    contentTip: 'Supports HTML and variable placeholders',
    messageContent: 'Message Content',
    contentPlaceholder: 'Enter message content with optional HTML and variable placeholders',
    requiredTip: 'Fields marked with * are required',
  },
  settings: {
    bind: 'Bind',
    bindBrand: 'Bind Brand',
    bindSpec: 'Bind Specs',
    bindParams: 'Bind Parameters', // 修正术语及大小写
    associateBrand: 'Associate Brand',
    categoryLevel: 'Category Level',
    primaryClassification: 'Primary Classification',
    addSubcategory: 'Add Subcategory',
    optionalValues: 'Option Values', // 优化术语
    parameter: 'Parameter',
    parameterGroup: 'Parameter Group',
    noParameter: 'No parameter binding information available',
    warehouseCode: 'Warehouse Code',
    warehouseName: 'Warehouse Name',
    warehouseSystem: 'Warehouse System',
    warehouseAlias: 'Warehouse Alias',
    address: 'Address',
    countryCode: 'Country',
    city: 'Town/City',
    email: 'Email',
    addWarehouseDic: 'Add Warehouse',
    editWarehouseDic: 'Edit Warehouse',
    warehouseDrawerSubtitle: 'Enter the warehouse address details used for order and logistics matching.',
    warehouseBasicInfo: 'Basic Information',
    warehouseAddressInfo: 'Address Information',
    warehouseAddressHint: 'Street, building number, etc.',
    optional: 'Optional',
    deliveryInfoSubtitle: 'View delivery rates for UK mainland and remote areas for this warehouse.',
    applicableWarehouse: 'Warehouse',
    deliveryCurrency: 'Currency',
    deliveryUpdatedAt: 'Updated At',
    viewRemotePostcodeRange: 'View remote-area postcode',
    remotePostcodeTitle: 'Remote-area Postcode',
    remotePostcodeDescription: 'Postcode details for Yodel service centres and local areas',
    remotePostcodeTip: 'Postcodes listed below are treated as remote areas and use the remote-area delivery rates.',
    warehouseEmail: 'Warehouse Email',
    warehouse: 'Warehouse',
    postCode: 'Postcode', // 修正术语
    warehouseInfo: 'Warehouse Information',
    basicOrderRules: 'Basic Order Rules',
    maximumOrderAmount: 'Maximum Order Amount Limit',
    minimumOrderAmountLimit: 'Minimum Order Amount Limit',
    PaymentValidityPeriod: 'Payment Validity Period',
    MinimumUnitPrice: 'Minimum Pre-order Unit Price',
    confirmRuleModification: 'confirm Order Configuration Rule Modification?',
    confirmSellerRuleModification: 'confirm Seller Configuration Rule Modification?',
    seconds: 'Seconds',
    freightOwnerFeePolicy: 'Freight Owner Fee Policy',
    settlementCycle: 'Settlement Cycle configuration',
    platformSalesCommission: 'The service fee percentage charged by the platform based on transaction volume',
    platformFee: 'Platform Fee',
    storeRentalFee: 'Store Rental Fee',
    storageHostingFee: 'Storage Hosting Fee(£/item/month)',
    returnLossFee: 'Return Loss Fee(£/package)',
    packagingLaborFee: 'Packaging & Labor Fee(£/package)',
    entryMode: 'Entry Mode',
    selfManagement: 'Self-operated Seller',
    hurixSelfManagement: 'HURIX Self-operated',
    fullyManaged: 'Fully Managed Seller',
    storeFee: 'Waived in the first year, charged by calendar month from the second year onward',
    settlementHandlingFee: 'Settlement Handling Fee',
    paymentServiceCharge: 'Payment Service Charge',
    refundServiceCharge: 'Refund Service Charge',
    thirdPartyFee: 'Third-Party Payment Platform Fee',
    changeNotification: 'Change Notification',
    effectNextMonth: 'The changes you made to the charges will take effect from next month onwards.',
    specification: 'Specification',
    bindSpecification: 'Bind Specification',
    addSpecification: 'Add Specification',
    editSpecification: 'Edit Specification',
    specificationDetails: 'Specification Details',
    valueGrouping: 'Value Grouping',
    groupName: 'Group Name',
    totalValues: 'Total Values',
    inputAndPressEnter: "Input value and press Enter to add",
    inputTip: "Tip: Press Enter to add new value",
    deleteGroup: "Are you sure you want to delete this group? ",
    groupExists: 'Group name already exists',
    returnLabel: 'Return Label',
    returnLabelConfiguration: 'Return Label Configuration',
    effectiveCurrentMonth: 'Effective current month: ',
    salesCommissionRate: 'Profit share(%)',
    salesCommissionRateTips: 'Platform commission rate',
    salesCommission: 'Sales Commission(£)',
    commissionFreePeriod: 'Commission Free Service Fee Period(month)',
    commissionFreePeriodTips: 'From the next month onwards, the seller will not be charged for the service fee',
    commissionFreePeriodData: 'Commission Free Service Fee Period',
    fixed: '(£)',
    deductionAmount: 'Deduction Amount',
    amountDue: 'Amount Due',
    price: 'Price',
    weightRange: 'Weight Range',
    britishMainland: 'UK Mainland',
    months: 'months',
    general: 'General',
  },
  tableColumns: {
    operator: 'Operator',
    time: 'Time',
    currentState: 'Current Status', // 统一术语为 Status
    creditValueBeforeChange: 'Previous Credit Value', // 优化对称性
    currentCreditValue: 'Current Credit Value'
  },
  im: {
    searchForContacts: 'Search for contacts',
    ChatLog: 'Chat History',
    send: 'Send',
    wouldLikeTalk: 'What would you like to talk about...',
    noMore: 'No more messages',
    imageFormat: 'Unsupported image format. Allowed types: JPG, JPEG, PNG',
    withdraw: 'Withdraw',
    platformMessage: 'Message',
    Buyers: 'Buyers',
    Sellers: 'Sellers',
    CustomerSupportGroup: 'Customer Support Group',
    groupMembers: 'Group Members',
    StartChat: 'Start Chat',
    NoStoreObtained: 'No goods owner information was obtained',
    mobileView: 'Mobile View',
    messageNotifications: 'Notifications',
    batchReconciliation: 'Batch Reconciliation',
    batchSettlement: 'Batch Settlement',
    allMessages: 'All Messages',
    connectionStatus: 'Connection Disconnected',
    csConnectionError: 'Connection Interrupted. Please Try Reconnecting',
    reconnectAction: 'Reconnect',
    noNotifications: 'No Notifications',
    contactBuyer: "Contact Buyer",
    noBuyerInfo: "Failed to obtain buyer information",
  },
  settlement: {
    settlementCycle: 'Settlement Cycle',
    ReservationOrderNo: 'Pre-order Number', // 变量名建议小驼峰
    payAmount: 'Amount Payable',
    deductionType: 'Deduction Type',
    CompleteTime: 'Order Completion Date', // 修正拼写错误
    status: 'Settlement Status',
    time: 'Settlement Time',
    settlement: 'Settlement',
    orderCreatedTime: 'Order Created Time',
    returnToPendingSettlement: 'Back',
    pendingSettlement: 'Pending Settlement',
    delayedSettlement: 'Delayed Settlement',
    isDelay: 'Is Delay',
    normal: 'Normal',
    settled: 'Settled',
    orderNo: 'Order Number',
    settlementFailed: 'Settlement Failed',
    confirm: 'Are you sure you want to settle the current order?',
    tradingTime: 'Trading Time',
    platformTransactionId: 'Platform Transaction ID',
    reconciliation: 'Reconciliation',
    reconciliationStatus: 'Reconciliation Status',
    myMoneyTransactionId: 'External Transaction ID',
    transactionAmount: 'Platform Transaction Amount(£)',
    outTransaction: 'External Transaction',
    outTransactionAmount: 'External Transaction Amount',
    myMoneyFee: 'External Fee',
    myMoneyTax: 'External Tax',
    platformReceivedAmount: 'Platform Received Amount',
    transactionType: 'Transaction Type',
    reconciliationResult: 'Reconciliation Result',
    discrepancyType: 'Discrepancy Type',
    reconciliationTime: 'Reconciliation Time',
    transactionDetails: 'Transaction Details',
    transactionInfo: 'Transaction Information',
    transactionInfoTip: 'Platform and external transaction information',
    amountInfo: 'Amount Information',
    amountInfoTip: 'Amount breakdown for this transaction',
    paymentReconciliationInfo: 'Payment and Reconciliation',
    paymentReconciliationInfoTip: 'Payment method and current reconciliation result',
    reconciliationDetailNote: 'This transaction has been reconciled. The platform and external transaction amounts match, and the result is balanced.',
    adjustmentAmount: 'Adjustment Amount(£)',
    adjustmentRemark: 'Adjustment Remark',
    adjustment: 'Adjustment',
    orderSnTooltip: 'Multiple order numbers can be entered, separated by commas',
    orderSnPlaceholder: 'Please enter order number, multiple orders separated by commas',
    uploadReconciliationFile: 'Upload Reconciliation File',
    unreconciled: 'Unreconciled',
    reconciling: 'Reconciling',
    completed: 'Completed',
    balanced: 'Balanced',
    imbalanced: 'Imbalanced',
    overage: 'Overage',
    shortage: 'Shortage',
    amountMismatch: 'Amount Mismatch',
    restrictions: 'Supports xlsx/xls/csv files, with a size limit of 10MB',
    addCustomFee: 'Add custom fee',
    feeDetailList: 'Settlement fee details',
    uploadSettlementStatement: 'Upload settlement statement Excel',
    customizeExpenseDetails: 'Customize expense details',
    feeCount: '{count} items',
    noCustomFee: 'No custom fees yet',
    customFeePlaceholder: 'Fee Name',
    customFeeDescription: 'Fee Description',
    customFeeDescriptionPlaceholder: 'Describe this fee',
    feeTitle: 'Fee Title',
    feeDescription: 'Fee Description',
    settlementImpact: 'Settlement Impact',
    deduct: 'Deduct',
    increase: 'Add',
    feeTitleHint: 'Used to identify this fee in the settlement statement.',
    feeDescriptionHint: 'Briefly describe the purpose of this fee.',
    settlementImpactHint: 'Apply this amount as a deduction or addition.',
    feeAmountHint: 'Enter a positive amount only.',
    settledTitle: 'Settled Fees',
    uploadFileFormatTip: 'Supported file formats are .pdf, .xlsx, .xls and .csv',
    platformAdvanceLogisticsFee: 'Return shipping fee(£)',
    shippingCostCompensation: 'Shipping compensation(£)',
    ownerSettlementAmount: 'Settlement amount(£)',
    estimatedSettlementAmount: 'Estimated settlement amount(£)',
    actualOrderAmount: 'Actual order amount(£)',
    paymentAmount: 'Payment amount(£)',
    orderTransactionRecord: 'Order transaction record',
    fileName: 'File Name',
    file: 'File',
    invoiceDrawerSubtitle: 'View settlement statements, reconciliation statements, and platform invoices generated for each shop in the settlement cycle',
    shopCount: 'Shops',
    fileTotal: 'Total Files',
    fileRecords: 'File Records',
    fileRecordSummary: '{shops} shops, {files} settlement files',
    settlementStatement: 'Settlement Statement',
    reconciliationStatement: 'Reconciliation Statement',
    platformInvoice: 'Platform Invoice',
    invoiceFooterTip: 'Download generated files for settlement archiving, financial reconciliation, or invoice records.',
    downloadInvoice: 'Download Invoice',
    selectSettleCycle: 'Please select a settlement cycle.',
    salesShippingTrackingNumber: 'Sales Shipping Tracking Number',
    shippingFee: 'Shipping Fee(£)',
    returnShippingTrackingNumber: 'Return Shipping Tracking Number',
    totalProductPrice: 'Total Product Price(£)',
    cardPaymentRefundFee: 'Refund Processing Fee',
    amount: 'Amount',
    transferIn: 'Transfer In',
    withdrawal: 'Withdrawal',
    repurchaseRefund: 'Repurchase Refund',
    repurchase: 'Repurchase',
    transactionNo: 'Transaction No',
    balance: 'Balance',
    transactionSerialNo: 'Transaction Serial No',
    applySerialNo: 'Application Serial No.',
    enterTransactionSerialNo: 'Enter transaction serial number',
    bankCardNo: 'Bank Card No',
    bankAccountName: 'Bank Account Name',
    bankName: 'Bank Name',
    branchCode: 'Branch Code',
    flowNo: 'Deduction Serial No',
    outPaymentNo: 'Payment Serial No',
    withdrawalRemark: 'Withdrawal Remark',
    copyCardNumber: 'Copy Card Number',
    copyFailed: 'Copy Failed',
    cardNumberCopied: 'Card number copied to clipboard',
    completeCardNumber: 'Complete Card Number',
    paymentChannelReconciliation: 'MyMoney Reconciliation',
    mobileReconciliation: 'WeChat & Alipay Reconciliation',
    cardReconciliation: 'Stripe Reconciliation',
    balanceReconciliation: 'Balance Reconciliation',
    balanceApplication: 'Balance Application',
    preOrderRelease: 'Pre-order Release',
    preOrderDepositRefund: 'Pre-order Deposit Refund',
    preOrderExpiryRefund: 'Pre-order Expiry Refund',
    platformSubsidy: 'Platform Subsidy - Card Binding',
    estimatedDebt: 'Estimated Debt Settlement',
    platformSettlement: 'Platform Settlement',
    platformSubsidies: 'Platform Subsidy - Other',
    sourceNotes: 'Source Notes',
    internalOrder: "Internal Order",
    internalOrderRefund: "Internal Order Refund",
    // 英文
    warehouseFeeLabel: "Warehouse Fee",
    warehouseFeeRefundLabel: "Warehouse Fee Refund",
    unsettled: 'Unsettled',
    unsettledDesc: 'The amount of unsettled orders, including orders that have been completed but do not meet the settlement criteria.Once an order meets the settlement requirements, you may initiate the settlement process via the Settle Now button below.',
    goSettlement: 'Settle Now',
    goSettlementDesc: 'After selecting the settlement period, the system will display the details of orders eligible for settlement within that period. You can view the order list, confirm the settlement amount, and then click the settlement button to complete the settlement process.',
    settledOrders: 'Settled Orders',
    settledOrdersDesc: 'Settled order amounts, including completed orders that have met settlement conditions. The page displays details of settled orders within the selected settlement period, including product amounts, shipping fees, refunds, platform fees and other itemized details.',
    unsettledReason: 'Unsettled Reason',
    expectedSettlementTime: 'Expected Settlement Time',
    activity: 'Activity',
    qty: 'Qty',
    netAmount: 'Net Amount (Excl. VAT)',
    vat: 'VAT',
    amountIncludeVat: 'Amount (Incl. VAT)',
    expectedSettlementAmount: 'Expected settlement amount',
  },
  afterSale: {
    sellerReviewDeadlinePrompt: 'The seller is required to complete the review by',
    noAction: 'If no action is taken by the deadline, it will be automatically approved.',
    timedOutStatus: '00:00:00',
    BuyerAppliesReturn: 'Buyer applies for a return',
    InProcessing: 'In processing',
    ReviewCompleted: 'Review completed',
    ReturnProcessing: 'Return in processing',
    BuyerInitiatesReturn: 'Buyer initiates a return request',
    AfterSalesInformation: 'After-sales Information',
    RefundAfterReceiptProducts: 'Refund after receipt of products',
    ProductsReceived: 'Products received',
    ProductsNotReceived: 'Products not received',
    AfterSalesNo: 'After-sales No.',
    ApplicationAmount: 'Application Amount',
    BuyerEntitledRefund: 'Buyer\'s Entitled Refund',
    AfterSalesReason: 'After-sales Reason',
    AfterSalesType: 'After-sales Type',
    ReceiptStatus: 'Receipt Status',
    ApplicationQuantity: 'Application Quantity',
    QuantityToReturn: 'Quantity of Items to Return',
    CustomerServiceArbitration: 'Platform Processing Result',
    Return: 'Return',
    TransactionInformation: 'Transaction Information',
    RefundRequestAmount: 'Refund Request Amount',
    sellerRefusedReturn: 'The seller refused the return',
    returnReviewApprovedAwaitingShip: 'Return Review Approved, awaiting buyer to ship',
    awaitingBuyerShip: 'Awaiting buyer to ship',
    awaitingSellerReceive: 'Awaiting seller to receive',
    afterSalesCompleted: 'After-sales Completed',
    ReturnShippingInfo: 'Return Shipping Info',
    ReturnShippingUpdates: 'Return Shipping Updates',
    buyerHasShipped: 'The buyer has shipped, the return item is in transit',
    ReturnRefund: 'Return & Refund',
    returnItemDeliveredAwaitingSign: 'Return item has been delivered, awaiting seller\'s signature',
    returnCompletedProceedRefund: 'Return has been completed, proceeding to refund process',
    noReturnOnlyRefundSuccessful: 'No return required, only refund has been successful',
    refundNumber: 'Refund Number',
    refundTime: 'Refund Time',
    buyerInitiatesOrderCancellation: 'Buyer initiates order cancellation',
    sellerReviews: 'Seller reviews',
    buyerSubmittedOrderCancellation: 'Buyer has submitted an order cancellation request',
    cancellationInProgressUrgeReview: 'Order cancellation request is in progress, please review it soon!',
    cancellationRequestApproved: 'Order cancellation request has been approved',
    cancellationApprovedProceedRefund: 'Order cancellation request has been approved and will proceed to the refund process',
    sellerRejectedCancellation: 'Seller has rejected the order cancellation',
    cancellationRequestRejected: 'Order cancellation request has been rejected',
    unshippedRefund: 'Unshipped Refund',
    AmountApplied: 'Amount Applied for Refund',
    RefundDestination: 'Refund Destination',
    requestedRefundAmount: 'Requested Refund Amount',
    actualRefundAmount: 'Actual Refund Amount',
    refundFromSellerToBuyer: 'Refund to the buyer from the seller\'s order payment',
    buyerPaymentMethod: 'Buyer\'s Payment Method',
    merchantPayoutMethod: 'Merchant Payout Method',
    productPayment: 'Product Fee',
    autoCancelOrderOnTimeout: 'Auto-Cancel Order on Timeout',
    autoConfirmReceiptPrompt: 'The order will be automatically confirmed as received after',
    receiptDueTime: '',  // 为空有用不要删
    ReturnAndRefundSupported: 'Return and refund supported',
    ReturnsRefundsNotSupported: 'Return and refund are not supported',
    GotoReview: 'Go to Review',
    reviewTimeoutAutoApproved: 'Review has timed out and is automatically approved',
    shipmentTimeoutAutoCancelled: 'Shipment has timed out, and the order has been automatically cancelled',
    orderAutoConfirmedReceipt: 'The order has been automatically confirmed as received',
    Type: 'Type',
    returnPath: 'Return Path',
    returnPathDetail: 'Buyer - Wallet - Balance',
    preOrderDepositDeduction: 'Pre-order Deposit Deduction',
    preOrderReleaseStock: 'Pre-order releases stock',
    preOrderSettlement: 'Pre-order settlement',
    returnArbitrationPending: 'You have pending matters for platform intervention',
    returnAuditInProgress: 'Return application under review',
    cancelAuditInProgress: 'Order cancellation under review',
    afterSaleHandle: "After-sales Handling",
    fillHandleInfoTip: "Please fill in the processing result and relevant information",
    handleResult: "Processing Result",
  },
  editor: {
    characters: 'Characters',
    images: 'Images',
  },
  balance: {
    viewDeductionRecord: 'Deduction History',
    applicationHistory: 'Application History',
    deductionRecord: 'Deduction History',
    deductionStatus: 'Deduction Status',
    success: 'Success',
    failed: 'Failed',
    deductionMethod: 'Deduction Method',
    paymentStatus: 'Payment Status',
    paymentProcessing: 'Processing',
    paymentSuccess: 'Success',
    paymentCancelled: 'Cancelled',
    paymentFailed: 'Failed',
    failureReason: 'Failure Reason',
    bankCard: 'Bank Card',
    withdrawalAmount: 'Withdrawal Amount',
    deductionInfo: 'Deduction Information',
    deductionInfoTip: 'View the execution details of this seller deduction',
    settlementInfo: 'Settlement Information',
    deductionSettlementTip: 'Settlement information related to this deduction',
    deductionSuccessNote: 'This deduction has been completed using {method}. The payment status is {status}.',
    applicationInfo: 'Application Information',
    applicationInfoTip: 'View this debt application and its review result',
    reviewResult: 'Review Result',
    reviewReasonPlaceholder: 'Enter the review reason',
    applicationSettlementTip: 'Settlement cycle and time related to this application',
    applicationApprovedNote: 'This application has been approved. This record shows the historical debt application and its settlement information.',
    applicationRejectedNote: 'This application was rejected. This record shows the historical debt application and its settlement information.',
    applicationPendingNote: 'This application is pending review. This record shows the historical debt application and its settlement information.'
  },
  menu: {
    permission: 'Settings',
    dashboard: 'Dashboard',
    brandAudit: 'Brand Audit',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    warehouseList: 'Warehouse List',
    warehouse: 'Warehouse',
    roleList: 'Seller Roles',
    productList: 'Product List',
    productDetails: 'Product Details',
    productVerify: 'Product Review',
    platformVerify: 'Platform Review',
    productSort: 'Product Category',
    brandManagement: 'Brand Management',
    addBrand: 'Add Brand',
    editBrand: 'Edit Brand',
    specificationsList: 'Specifications List',
    unitOfMeasurement: 'Measurement Units',
    platformRole: 'Platform Roles',
    menuList: 'Menu List',
    shopMenu: 'Seller Menu',
    addMenu: 'Add Menu',
    updateMenu: 'Update Menu',
    resourceList: 'Resource List',
    platformUsers: 'Platform Users',
    mallUsers: 'Mall Users',
    shop: 'Seller',
    shopManagement: 'Seller Management',
    shopList: 'Seller List',
    shopApplyList: 'Seller Audit',
    reviewShop: 'Seller Review',
    order: 'Orders',
    platformOrders: 'Platform Orders',
    orderList: 'Order List',
    settlementList: 'Settlement List',
    pendingSettlement: "Pending Settlement",
    settledOrders: "Settled Orders",
    buyerBalance: "Buyer Balance",
    buyerBalanceDetail: "Buyer Balance Details",
    sellerBalance: "Seller Balance",
    sellerBalanceDetail: "Seller Balance Details",
    settlementDebt: "Settlement Debt",
    reconciliationList: 'Reconciliation List',
    settings: 'Product Configuration',
    parameterBinding: 'Parameter Binding',
    warehouseAudit: 'Warehouse Audit',
    creditValue: 'Credit Score',
    creditValueList: 'Credit Score List',
    business: 'Reseller',
    platform: 'Platform',
    Marketing: 'Marketing',
    SecondKillActivityList: 'Flash Sale Activity List',
    SecondsKillTimeList: 'Flash Sale Period List',
    SecondsKillTimeSelection: 'Flash Sale Time Selection',
    SeckillProductList: 'Flash Sale Product List',
    CouponList: 'Coupon List',
    AddCoupons: 'Create Coupon',
    ModifyCoupon: 'Edit Coupon',
    CouponCollectionDetails: 'Coupon Collection Details',
    BrandRecommendation: 'Brand Recommendations',
    NewProductRecommendation: 'New Product Recommendation',
    PopularRecommendation: 'Popular Recommendation',
    SpecialTopicRecommendation: 'Special Topic Recommendation',
    AdvertisingList: 'Advertising List',
    AddAds: 'Create Ad',
    EditorialAdvertising: 'Edit Ad',
    Permissions: 'Permissions',
    AllocatingResources: 'Resource Allocation',
    ResourceClassification: 'Resource Categories',
    settleDetails: 'Settlement Details',
    template: 'Template',
    emailTemplates: 'Message Template',
    SystemConfiguration: 'System Configuration',
    product: 'Product',
    financial: 'Financial',
    AfterSalesDetails: 'After-sales Details',
    payment: 'Payment',
    quotation: 'Quotation Management',
    mallUserAudit: "Distributor Audit",
    mallUserReviewDetail: "Distributor Audit Details",
    distributorAccountDetails: 'Distributor Account Details',
    reviewShopDetail: "Seller Audit Details",
    orderAuditList: 'Manage Returns',
  },
  entry: {
    merchantType: 'Merchant Type',
    enterpriseInfo: "Enterprise Information",
    individualMerchant: "Individual Merchant",
    enterpriseCompany: "Enterprise/Company",
    shopName: "Shop Name",
    certificateFiles: "Certificate Files",
    personalInfo: "Personal Information",
    legalPersonInfo: "Legal Representative Information",
    idProof: "ID Proof",
    idFullName: "Full Name on ID",
    corpNameTip: "Enterprise Name",
    corpRegNoLabel: "Enterprise Registration Number",
    idTypeLabel: "ID Document Type",
    ukPassportOption: "Passport",
    ukDrivingLicenceOption: "Driving Licence",
    channelOther: "Other",
    salesChannel: 'Sales Channel',
    uboTitle: "Ultimate Beneficial Owner (UBO)",
    legalRepIdDocLabel: "Legal Representative ID Document",
    corpProofTitle: "Enterprise Entity Proof",
    companiesHouseLabel: "Company Registration Certificate (Companies House)",
    ukVatCertLabel: "UK VAT Registration Certificate",
    supplementaryProofTitle: "Supplementary Supporting Documents",
    companyConstitutionLabel: "Memorandum & Articles of Association",
    businessAddrProofLabel: "Proof of Actual Business Address",
    bankAccountProofLabel: "Bank Account Proof",
    personalInfoTitle: "Personal Information",
    personalNameLabel: "Name (Consistent with ID Document)",
    birthDateLabel: "Date of Birth",
    idVerifyTitle: "Identity Verification",
    residenceVerifyTitle: "Residential Address Verification",
    bankStatementItem: "Bank Statement (Last 3 Months)",
    utilityBillItem: "Utility Bill (Water / Electricity / Gas, Last 3 Months)",
    netMobileBillItem: "Internet / Mobile Phone Bill (Last 3 Months)",
    rentalContractItem: "Rental Contract (Valid Period)",
    proofDocTypeLabel: "Proof Document Type",
    addressProofFileLabel: "Address Proof Document",
    entityType1: "UK Sole Trader",
    entityType2: "Overseas Entity + UK VAT",
    entityType3: "UK Established Entity",
    enterpriseName: "Enterprise Name",
    contactInfoTitle: "Contact Information",
    name: 'Name',
    phone: 'Phone Number',
    mainSalesScenarioLabel: "Primary Sales Scenario",
    salesTargetLabel: "Sell To",
    businessBriefLabel: "Business Overview",
    businessIntroductionTitle: "Business Overview",
    otherSupplementaryDocsLabel: "Other Supplementary Documents",
    proofDocsLabel: "Supporting Documents",
    businessLicense: 'Business license (or company registration certificate)',

    store: {
      title: 'Associated Store Information',
      onlineStore: 'Online Store(optional to fill in)',
      platformType: 'Platform Type',
      storeUrl: 'Store Link',
      storeName: 'Store Name',
      physicalStoreInformation: 'Physical store information(optional to fill in)',
      storeAddress: 'Store Address',
      storeImage: 'Store Photos',
      physicalStoreLabel: "Physical Store",
    },

    identity: {
      individual: 'Individual Entrepreneur / Freelancer',
      employee: 'Company / Enterprise Employee (Employee Benefit Sales)',
      student: 'Student',
      other: 'Other'
    },
  },
  "enterpriseApplication": {
    "personalInfo": {
      "businessInfo": "Business Information",
      "companyName": "Company Name",
      "registrationNumber": "Unified Social Credit Code / Registration Number",
      "companyType": "Company Type",
      "country": "Country/Region",
      "registerAddress": "Registered Company Address",
      "companyPhone": "Company Contact Phone",
      "contactInfo": "Contact Information",
      "contactPersonName": "Contact Name",
      "contactPosition": "Contact Position",
      "contactPhone": "Contact Phone"
    },
    "store": {
      "title": "Associated Store Information (At Least One Required)"
    },
    "vat": {
      title: 'VAT Information',
      "vatNo": "VAT Number"
    }
  },
  buyer: {
    evaluationContent: "Evaluation Content",
    evaluationImages: "Evaluation Images",
    ratingType: "Rating Type",
    ratingStars: "Rating Stars",
    displayStatus: "Display Status",
    positiveReview: "Positive Review",
    neutralReview: "Neutral Review",
    negativeReview: "Negative Review",
    hasImages: "Has Images",
    productReviews: 'Product Reviews',
    distAuditPending: "Distributor review is in progress, please wait",
  },
  wallet: {
    paymentStatusQuerying: 'Querying payment status',
    PaymentSuccessful: 'Payment successful',
    ProcessingPayment: 'Processing payment',
    committedProtectingInformation: 'We are committed to protecting your information',
    BillingAddress: 'Billing Address',
    editNewBillingAddress: 'Edit new billing address',
    payNow: 'Pay now',
    paymentNotSuccessful: 'Payment was not successful',
    SomeCommonIssues: 'Some common issues:',
    VerifyPaymentInformation: 'Verify payment information',
    bankHaveFlagged: 'Your bank may have flagged this transaction',
    withdrawalPurchaseLimits: 'Check your card\'s withdrawal or purchase limits',
  },
  register: {
    PoweredBy: 'Powered by',
    PoweredBy2: '',
    Clause: 'Terms',
    Privacy: 'Privacy',
    firstName: 'First Name',
    lastName: 'Last Name',
  },
  quotation: {
    title: 'HURIX Internal Quotation',
    subtitle: 'Intelligent Quotation · Precise Calculation · Efficient Management',
    quoteItems: {
      management: 'Quote Items Management',
      search: 'Search quote items...',
      add: 'Add Quote Item',
      edit: 'Edit Quote Item',
      addSubtitle: 'Maintain basic information, rates, and service content',
      editSubtitle: 'Update the current quote item; changes take effect after saving',
      basicInfo: 'Basic Information',
      rateSettings: 'Rate Settings',
      serviceContent: 'Service Content',
      name: 'Quote Item Name',
      nameEn: 'English Quote Item Name',
      rate: 'Default Rate',
      tax: 'Tax',
      taxRate: 'Tax Rate',
      visibility: 'Client Visibility',
      action: 'Action',
      inputName: 'e.g., International Air Freight (China-UK)',
      inputNameEn: 'e.g., International Air Freight (CN-UK)',
      visible: 'Visible',
      hidden: 'Hidden',
      visibleToClient: 'Visible to Client',
      required: 'Required',
      notes: 'Notes',
      inputNotes: 'Detailed description of this service...',
      inputNotesEn: 'Describe the service details, scope, and charging notes in English...',
      nameRequired: 'Please enter quote item name',
      nameEnRequired: 'Please enter English quote item name',
      saveSuccess: 'Quote item saved successfully',
      editSuccess: 'Quote item edited successfully',
      deleteConfirm: 'Are you sure you want to delete this quote item?',
      deleteSuccess: 'Quote item deleted successfully',
      cost: 'Default Cost',
      description: 'Service Content',
      descriptionEn: 'English Service Content',
      searchSuccess: 'Search successful',
      currency: 'Currency Symbol',
      currencyRequired: 'Please select currency symbol',
      rateRequired: 'Please enter default rate',
      costRequired: 'Please enter default cost',
      taxRateRequired: 'Please enter tax rate',
      minZero: 'Value cannot be less than 0'
    },
    templates: {
      management: 'Template Management',
      search: 'Search templates...',
      create: 'Create Template',
      edit: 'Edit Template',
      quoteItems: 'Quote Items',
      status: 'Status',
      usageCount: 'Usage Count',
      use: 'Use',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      transport: 'E-commerce',
      logistics: 'Logistics',
      custom: 'Custom',
      emptyDesc: 'No data available',
      name: 'Template Name',
      nameEn: 'English Template Name',
      description: 'Template Description',
      descriptionEn: 'English Template Description',
      type: 'Template Type',
      inputName: 'e.g., Standard International Transport Quote',
      inputNameEn: 'e.g., Standard International Transport Quote',
      inputDescription: 'Describe the purpose and features of this template...',
      inputDescriptionEn: 'Describe the purpose and features of this template...',
      selectItems: 'Select Items',
      templateInfo: 'Template Information',
      templateInfoTip: 'Maintain basic template information and type',
      selectQuoteItems: 'Select Quote Items',
      selectItemsTip: 'Select from the complete quote item list regardless of type',
      searchItems: 'Search quote item name or service content...',
      selectedCount: '{count} selected',
      itemCount: '{count} items',
      step1: '1',
      step2: '2',
      step3: '3',
      basicInfo: 'Basic Information',
      complete: 'Complete Setup',
      completeTip: 'Confirm the status and save the template',
      activeTip: 'The template can be used for quotations immediately after saving.',
      inactiveTip: 'Keep the template configuration without using it for quotations.',
      noSelectedItems: 'No quote items selected',
      footerTip: 'Step two shows the complete quote item list and supports name or service searches.',
      prevStep: 'Previous',
      nextStep: 'Next',
      nameRequired: 'Please enter template name',
      nameEnRequired: 'Please enter English template name',
      itemsRequired: 'Please select at least one quote item',
      createSuccess: 'Template created successfully',
      editSuccess: 'Template edited successfully',
      quickCreateInfo: 'Quick create template feature is under development',
      deleteConfirm: 'Are you sure you want to delete this template?',
      deleteSuccess: 'Template deleted successfully',
      update: 'Update',
      updateTime: 'Update Time'
    },
    quoteManagement: {
      title: 'Quote Management',
      addQuote: 'Add Quote',
      back: 'Back',
      selectTemplate: 'Select Template',
      inputClient: 'Enter client name',
      inputQuoteNumber: 'Enter quote number',
      selectDate: 'Select date',
      validDateRequired: 'Please select valid date',
      search: 'Search',
      reset: 'Reset',
      quoteNumber: 'Quote No',
      clientName: 'Customer',
      template: 'Template',
      validDate: 'Valid Until',
      createDate: 'Create Date',
      actions: 'Actions',
      preview: 'Preview',
      previewQuote: 'Preview Quote',
      download: 'Download',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this quote?',
      deleteSuccess: 'Quote deleted successfully',
      downloadSuccess: 'Quote downloaded successfully',
      searchSuccess: 'Search successful',
      // Create quote related
      basicInfo: 'Quote Information',
      basicInfoTip: 'Select a template, customer, and valid date',
      quoteItems: 'Quote Items',
      itemsTip: '{count} items · Quantity, unit price, and tax rate can be adjusted directly',
      quoteTotal: 'Quote Total',
      costTotal: 'Total Cost',
      client: 'Customer',
      item: 'Item',
      quantity: 'Qty',
      price: 'Unit Price',
      tax: 'Tax',
      taxRate: 'Tax Rate',
      amount: 'Amount',
      profit: 'Profit',
      tip: 'Tip: Internal cost items will not be shown to clients',
      clear: 'Clear and Re-enter',
      calculate: 'Recalculate',
      save: 'Save Quote',
      templateSelected: 'Template selected successfully',
      calculated: 'Calculation completed',
      cleared: 'Form cleared',
      saved: 'Quote saved successfully',
      amountFormula: 'Formula: Quantity × Unit Price × (1 + Tax Rate%)',
      cost: 'Unit Cost',
      finalCost: 'Final Cost',
      finalCostFormula: 'Final Cost = Quote Item Cost × Quantity',
      profitFormula: 'Formula: (Amount - Final Cost) / Amount × 100%',
      currencySymbol: 'Currency Symbol',
      selectTemplateFirst: 'Please select a template above',
      enterCustomerName: 'Please enter customer name',
      quoteNotEmpty: 'Quote cannot be empty',
      // Preview related
      fullscreen: 'Fullscreen',
      exitFullscreen: 'Exit Fullscreen',
      formalQuotation: 'Formal Quotation',
      quoteDate: 'Date',
      notFilled: 'Not Filled',
      subtotal: 'Subtotal',
      subtotalDesc: '{count} items',
      taxDesc: 'Total Tax',
      total: 'Total',
      totalDesc: 'Inc. Tax',
      export: 'Export',
      exportSuccess: 'Export Successful'
    },
    help: {
      title: 'Usage Help',
      guide: 'Quick Start Guide',
      features: 'Feature Introduction',
      tips: 'Usage Tips',
      faq: 'Frequently Asked Questions',
      step1: 'Step 1: Manage Quote Items',
      step2: 'Step 2: Create or Select Template',
      step3: 'Step 3: Generate Quote',
      step4: 'Step 4: Preview and Export',
      step1Desc: 'Add your charge items in "Quote Items Management", including name, unit price and tax rate. You can edit existing items or delete unnecessary ones.',
      step2Desc: 'Create quote templates in "Template Management", or select existing templates for editing. Templates can contain multiple quote items for quick quote generation.',
      step3Desc: 'Select a template in "Create Quote", and the system will automatically load the quote items from the template. You can adjust quantity, unit price and other information as needed.',
      step4Desc: 'Click "Preview Quote" button to view the final result, and click "Generate PDF" to export the quote after confirmation.',
      feature1: 'Quote Items Management: Add, edit, delete charge items, set basic information and prices.',
      feature2: 'Template Management: Create and manage quote templates, quickly reuse common quote item combinations.',
      feature3: 'Quote Generation: Quickly generate quotes based on templates, supporting real-time cost and profit calculation.',
      feature4: 'Preview and Export: Real-time preview of quote effects, export to PDF format.',
      tip1: 'Using templates can greatly improve quoting efficiency. It is recommended to create templates for common quote combinations.',
      tip2: 'When creating a quote, you can directly modify the quantity and unit price of quote items, and the system will automatically recalculate costs and profits.',
      tip3: 'When previewing a quote, you can click the fullscreen button in the upper right corner to view the complete effect.',
      tip4: 'Profits in quotes will be displayed in different colors: green indicates profit, red indicates loss.',
      faq1: 'How to modify the tax rate of a quote item?',
      faq1Desc: 'Edit the quote item in Quote Items Management, or directly modify the tax rate of the corresponding row when creating a quote.',
      faq2: 'How to quickly create multiple similar quotes?',
      faq2Desc: 'Create a template containing common items, then create new quotes based on that template.',
      faq3: 'How to adjust the style of the quote?',
      faq3Desc: 'The system currently uses fixed quote templates, style adjustments require contacting technical support.',
      faq4: 'Where are the exported PDF files saved?',
      faq4Desc: 'PDF files will be directly downloaded to your browser\'s default download directory.'
    }
  },
  returnParcel: {
    managementTitle: 'Return Parcels',
    navigationLabel: 'Return parcel management',
    packageCenter: 'Parcel Centre',
    taskCenter: 'Tasks',
    rulesAndFees: 'Rules & Fees',
    packageCenterDescription: 'View all returns received by the NGT warehouse, their current status, and complete handling history.',
    lastUpdated: 'Last updated: {time}',
    number: 'Number',
    all: 'All',
    pleaseSelect: 'Please select',
    notSubmitted: 'Not submitted',
    unlinkedOrder: 'No linked order',
    unlinked: 'Not linked',
    unrecognized: 'Not recognised',
    notProvided: 'Not provided',
    notApplicable: 'Not applicable',
    pendingConfirmation: 'Pending confirmation',
    distributorPending: 'Distributor pending',
    ownerPending: 'Owner pending',
    thirdPartyOrder: 'Third-party order number',
    orderNumber: 'HURIX order number',
    returnOrderNumber: 'HURIX return number',
    ngtPackageNumber: 'NGT parcel number',
    applicationNumber: 'Parcel claim application ID',
    returnTrackingNumber: 'Return tracking number',
    ngtWarehouse: 'NGT Warehouse',
    operator: 'Operator',
    publicClaimApplication: 'Public claim application',
    waitingPlatform: 'Waiting for platform',
    exceptionCreated: 'Exception created',
    internalSettlement: 'Platform internal settlement',
    platformInternalSettlement: 'HURIX platform internal settlement',
    noPaymentRequired: 'No payment required',
    paymentSucceeded: 'Payment successful',
    systemAutomaticInstruction: 'Automatic system instruction',
    systemInstruction: 'System instruction',
    // Parcel centre list
    packageTabAll: 'All Parcels',
    packageTabPending: 'Pending',
    packageTabStorage: 'Storage',
    packageTabCompleted: 'Completed',
    filterKeyword: 'Enter return tracking number / package code / order number',
    filterAllStatuses: 'Select a status',
    filterEmail: 'Enter an email',
    filterAllAuditStatuses: 'Select an audit status',
    filterAllMatchMethods: 'Select a match method',
    columnParcelProduct: 'Parcel / Product',
    columnOrderInfo: 'Order Information',
    columnMatchMethod: 'Matching Method',
    columnCurrentStatus: 'Current Status',
    columnCreatedTime: 'Created Time',
    packageCount: '{count} parcels',
    packageStatusStorage: 'In storage',
    packageStatusPendingOwnerReview: 'Pending owner return review',
    packageStatusPlatformIntervention: 'Platform intervention',
    packageStatusPendingDistributorInstruction: 'Pending distributor instruction',
    packageStatusPublicClaim: 'Open for public claim',
    packageStatusPendingWarehouseClaimReview: 'Pending warehouse claim review',
    packageStatusPendingPlatformInstruction: 'Pending platform instruction',
    packageStatusPendingWarehouseExecution: 'Pending NGT warehouse execution',
    packageStatusWarehouseExecutionOverdue: 'Warehouse execution overdue',
    packageStatusCompleted: 'Completed',
    matchTypeUnmatched: 'Unmatched',
    matchTypeAutomatic: 'Automatic match',
    matchTypeLabelOrderNumber: 'Label order number match',
    matchTypePostcode: 'Postcode match',
    auditStatusPending: 'Pending review',
    auditStatusApproved: 'Approved',
    auditStatusRejected: 'Rejected',
    statusTimeInstructionDeadline: 'Instruction due: {time}',
    statusTimeFreeStorage: 'Free storage until: {time}',
    statusTimePublicClaimEnter: 'Public claim starts: {time}',
    statusTimePublicClaimExpire: 'Public claim ends: {time}',
    // To-do list
    taskTabAll: 'All Tasks',
    taskTabWarehouseReview: 'Warehouse Review',
    taskTabWarehouseExecution: 'Warehouse Execution',
    taskTabPlatformReview: 'Platform Review',
    taskTabException: 'Exception Parcels',
    taskFilterAll: 'All',
    taskAuditApproved: 'Approved',
    taskAuditRejected: 'Rejected',
    taskAllDescription: 'All returns requiring manual action are collected in one queue for centralised review and handling.',
    taskAllNotice: 'When a public claim expires unclaimed, or a distributor discards a parcel, it enters Platform Review. After the platform selects listing, discard, or destruction, the NGT warehouse executes the instruction.',
    taskWarehouseReviewDescription: 'The NGT warehouse compares distributor claim evidence with the physical parcel to confirm ownership.',
    taskWarehouseReviewNotice: 'The public-claim countdown pauses after an application is submitted. If rejected, it resumes from the remaining time saved at submission.',
    taskWarehouseExecutionDescription: 'Execute paid distributor instructions or listing, discard, and destruction instructions issued after the platform takes ownership.',
    taskWarehouseExecutionNotice: 'Distributor instructions require confirmed payment; platform-owned parcels use internal settlement. The warehouse must execute the issued instruction without changing it.',
    taskPlatformReviewDescription: 'Review unclaimed or discarded parcels owned by the platform and issue disposal instructions to the NGT warehouse.',
    taskPlatformReviewNotice: 'The platform can choose List on HURIX, Discard, or Destroy. Listed products enter HURIX saleable inventory for continued sale.',
    taskExceptionDescription: 'Handle parcels that exceed the warehouse execution deadline and require platform intervention.',
    taskExceptionNotice: 'Adjusting the deadline does not cancel the original instruction or payment. Every change records the operator, reason, and before-and-after values.',
    taskCount: '{count} tasks',
    columnCandidateOrders: 'Candidate Orders',
    columnSubmittedAt: 'Submitted At',
    columnInstructionParty: 'Instruction Party',
    columnEntryReason: 'Entry Reason',
    matchScore: 'Match score {score}%',
    platformReviewReasonPublicClaimExpired: 'Public claim expired unclaimed',
    platformReviewReasonDistributorDiscard: 'Distributor discarded parcel',
    exceptionWarehouseOverdueNote: 'The forwarding instruction has not been completed within one business day. The original instruction and payment remain valid, and a new execution deadline is required.',
    feeRecordCount: '{count} fee records',
    feePaymentStatusPlaceholder: 'Select a payment status',
    feeReturnExpressNoPlaceholder: 'Enter a return tracking number',
    feeEmailPlaceholder: 'Enter an email',
    feeReturnPackage: 'Return Parcel',
    feeDistributor: 'Distributor',
    // Return parcel details
    detailTitle: 'Return Parcel Details',
    detailCreatedAt: 'Created At',
    detailProcessingTime: 'Processing Deadlines',
    detailParcelInfo: 'Parcel Information',
    detailCarrier: 'Carrier',
    detailStorageDeadline: 'Storage Deadline',
    detailInstructionDeadline: 'Instruction Deadline',
    detailLinkedInfo: 'Linked Information',
    detailThirdPartyPlatform: 'Third-party Platform',
    detailMatchingCriteria: 'Matching Criteria',
    detailPublicClaimEnterTime: 'Public Claim Start Time',
    detailPublicClaimExpireTime: 'Public Claim Expiry Time',
    detailProductsAndImages: 'Products & Parcel Images',
    detailPackageImage: 'Parcel Image',
    noPackageImage: 'No parcel image',
    detailProductInfo: 'Product Information',
    detailProductName: 'Product Name',
    detailProductSpec: 'Product Variant',
    warehouseRentDurationValue: '{count} days',
    detailFees: 'Storage & Fees',
    detailWarehouseOperationsFee: 'Warehouse Handling Fee',
    detailWarehouseOperationsTimes: 'Warehouse Operations',
    detailShippingFee: 'Forwarding Delivery Fee',
    detailPaymentAmount: 'Payment Amount',
    detailWarehouseRent: 'Storage Fee',
    detailWarehouseRentDuration: 'Storage Duration',
    detailPaymentNumber: 'Payment Number',
    detailPaymentStatus: 'Payment Status',
    detailPaymentTime: 'Payment Time',
    detailCommand: 'NGT Warehouse Instruction',
    detailCommandType: 'Instruction Type',
    detailCommandStatus: 'Instruction Status',
    detailRemark: 'Remark',
    detailLogisticsCarrier: 'Logistics Carrier',
    detailLogisticsNumber: 'Tracking Number',
    detailWeight: 'Weight',
    detailLogisticsTime: 'Forwarding Time',
    detailExecutionResult: 'Execution Result',
    detailForwardingAddress: 'Forwarding Address',
    detailVoucherFiles: 'Voucher Files',
    detailNoCommand: 'No warehouse instruction',
    detailRecords: 'Complete Handling Log',
    detailOperator: 'Operator',
    detailNoRecords: 'No handling records',
    recordStatusUnknown: 'Unknown',
    recordStatusReturnSubmitted: 'Return request submitted',
    recordStatusOwnerApproved: 'Owner approval: approved',
    recordStatusOwnerRejected: 'Owner approval: rejected',
    recordStatusPlatformIntervention: 'Platform intervention',
    recordStatusParcelArrived: 'Parcel arrived at warehouse',
    recordStatusParcelMatched: 'Parcel matched',
    recordStatusMatchSucceeded: 'Parcel match successful',
    recordStatusPublicClaimStarted: 'Parcel entered public claim',
    recordStatusClaimSubmitted: 'Claim record submitted',
    recordStatusClaimApproved: 'Claim application approved',
    recordStatusClaimRejected: 'Claim application rejected',
    recordStatusPendingDistributorInstruction: 'Pending distributor instruction',
    recordStatusDistributorInstructionIssued: 'Distributor instruction issued',
    recordStatusPlatformHandling: 'Timed out and handed to platform',
    recordStatusWarehouseDelayed: 'Warehouse handling delayed',
    recordStatusWarehouseCompleted: 'Warehouse handling completed',
    recordStatusPlatformInstructionIssued: 'Platform Issued Instruction',
    detailLocation: 'Warehouse Location',
    detailSettlementStatus: 'Settlement Status',
    detailPaidWithNumber: 'Paid · {number}',
    detailCurrentOwnership: 'Current Ownership',
    photoOuterPackage: 'Outer Package',
    photoProduct: 'Product',
    paymentStatusNone: 'No payment required',
    paymentStatusPending: 'Pending payment',
    paymentStatusPaid: 'Paid',
    commandTypeStorage: 'Store',
    commandTypeDestroy: 'Destroy',
    commandTypeDiscard: 'Discard',
    commandTypeForward: 'Forward',
    commandTypeStock: 'List on HURIX',
    commandStatusCreated: 'Created',
    commandStatusPendingPayment: 'Pending payment',
    commandStatusExecuting: 'In progress',
    commandStatusCompleted: 'Completed',
    commandStatusFailed: 'Failed to issue',
    // Detail actions and dialogs
    reviewClaim: 'Review Claim',
    reviewAndIssue: 'Review & Issue Instruction',
    executeInstruction: 'Execute Instruction',
    adjustDeadline: 'Adjust Deadline',
    rejectReview: 'Reject',
    approveReview: 'Approve',
    claimReviewTitle: 'Claim Review',
    approveClaimTitle: 'Confirm Claim Approval',
    rejectClaimTitle: 'Submit Claim Rejection',
    platformInstructionTitle: 'Platform Review & Disposal Instruction',
    executeCommandTitle: 'Execute {command} Instruction',
    adjustDeadlineTitle: 'Warehouse Execution Overdue',
    warehouseItem: 'Warehouse Item',
    warehouseInfo: 'Warehouse Information',
    claimMaterials: 'Distributor Claim Materials',
    claimApplicant: 'Applicant',
    outerPackage: 'Outer Packaging',
    productPhysical: 'Physical Product',
    claimDescription: 'Claim Description',
    claimVoucher: 'Claim Evidence',
    claimReviewNotice: 'The public-claim countdown is paused during review. Approval moves the parcel into distributor storage; rejection resumes the remaining claim time.',
    approveClaimNotice: 'After approval, the parcel is linked to the applicant and moved into storage. The free period, storage fee, and seven-business-day automatic discard deadline restart.',
    rejectReason: 'Rejection Reason',
    reviewNote: 'Review Note',
    reviewNoteRequired: 'Please enter the review note',
    reviewNotePlaceholder: 'Describe the review outcome or the information that must be added or corrected',
    internalNote: 'Internal Note (optional)',
    internalNotePlaceholder: 'Visible only to platform and NGT staff',
    auditVoucher: 'Review Evidence',
    claimApplicationRequired: 'The claim application number is unavailable. Refresh the details and try again.',
    returnPackageIdRequired: 'The return parcel ID is unavailable. Refresh the details and try again.',
    commandIdRequired: 'The return parcel command ID is unavailable. Refresh the details and try again.',
    returnSnRequired: 'The return number is unavailable. Refresh the details and try again.',
    platformInstructionNotice: 'The parcel has entered platform review. Select a disposal method; submission creates an NGT warehouse task.',
    disposalMethod: 'Disposal Method',
    disposalMethodRequired: 'Select a disposal method',
    stockCommandHelp: 'Move into HURIX saleable inventory after inspection for continued sale by HURIX',
    discardCommandHelp: 'Follow the warehouse discard process',
    destroyCommandHelp: 'Destroy the item and return handling evidence',
    stockHelpTitle: 'Listing Instructions',
    stockHelpDescription: 'The warehouse must inspect appearance, packaging, and basic function. Saleable items are listed on HURIX; items that fail inspection return to platform review.',
    platformRemarkPlaceholder: 'Describe product condition, review basis, and warehouse handling notes',
    instructionImmutable: 'Instruction content cannot be changed',
    carrierPlaceholder: 'Select a carrier',
    carrierRequired: 'Select a carrier',
    logisticsNumberPlaceholder: 'Enter the forwarding tracking number',
    logisticsNumberRequired: 'Enter the forwarding tracking number',
    logisticsNumberLengthAndDigitRule: 'Enter a 5-50 character tracking number containing at least one digit',
    logisticsNumberCharacterRule: 'Only letters, digits, and nonconsecutive hyphens (-) are allowed; do not start or end with a hyphen',
    actualWeight: 'Actual Weight (kg)',
    weightRequired: 'Enter the actual weight',
    weightMinZero: 'Actual weight cannot be less than 0',
    handoverTime: 'Handover Time',
    handoverTimeRequired: 'Select the handover time',
    selectTime: 'Select date and time',
    executionNote: 'Execution Note',
    executionResultRequired: 'Enter the execution note',
    executionResultPlaceholder: 'Record the actual result and any details requiring explanation',
    executionVoucher: 'Handling Evidence',
    deadlineRemaining: '{time} remaining',
    deadlineOverdue: 'Overdue by {time}',
    durationDayHour: '{days}d {hours}h',
    durationHourMinute: '{hours}h {minutes}m',
    originalDeadline: 'Original Execution Deadline',
    newDeadline: 'New Execution Deadline',
    newDeadlineRequired: 'Select a new execution deadline',
    adjustmentReason: 'Adjustment Reason',
    adjustmentReasonRequired: 'Enter the adjustment reason',
    adjustmentReasonPlaceholder: 'Explain why the execution window is being extended',
    rejectProductMismatch: 'Product does not match',
    rejectVariantMismatch: 'Variant or quantity does not match',
    rejectInvalidEvidence: 'Invalid order evidence',
    rejectOwnershipUnproven: 'Parcel ownership cannot be proven',
    rejectUnclearImages: 'Images are unclear',
    rejectOther: 'Other',
    productSummaryMore: '{name} and {count} products',
    confirmApprove: 'Confirm Approval',
    confirmReject: 'Confirm Rejection',
    confirmIssueInstruction: 'Confirm Review & Issue',
    confirmExecution: 'Confirm Completion',
    confirmDeadline: 'Confirm Deadline',
    uploadFailed: 'File upload failed',
    copiedMessage: '{label} copied',
    copyFailedMessage: 'Copy failed. Please select the number manually.',
    claimApprovedMessage: 'Claim approved and the parcel moved into distributor storage',
    claimRejectedMessage: 'Claim rejected and the public-claim countdown resumed',
    instructionIssuedMessage: 'Platform review completed',
    executionSavedMessage: 'Warehouse execution was saved and synced to parcel details',
    deadlineUpdatedMessage: 'The new execution deadline is now active',
    filtersTrackingNumber: 'Return tracking number',
    filtersDistributor: 'Distributor',
    filtersDistributorAccount: 'Distributor account',
    filtersAllCarriers: 'All carriers',
    timeDays: '{count}d',
    timeHours: '{count}h',
    timeMinutes: '{count}m',
    timeOverdue: 'Overdue by {time}',
    timeRemaining: '{time} remaining',
    statusPendingDistributorLink: 'Waiting for distributor to link parcel',
    statusPendingMatch: 'Pending match confirmation',
    statusPublicClaiming: 'Open for public claim',
    statusPendingWarehouseReview: 'Pending warehouse review',
    statusPendingOwnerReview: 'Pending owner return review',
    statusPendingDistributorInstruction: 'Pending distributor instruction',
    statusPendingPlatformReview: 'Pending platform review',
    statusPendingWarehouseExecution: 'Pending NGT warehouse execution',
    statusInStorage: 'In storage',
    statusWarehouseOverdue: 'Warehouse execution overdue',
    statusCompleted: 'Completed',
    statusDiscarded: 'Automatically discarded',
    statusDestroyed: 'Destroyed',
    statusForwarded: 'Forwarded',
    matchThirdOrder: 'Third-party order match',
    matchPostcodeCandidate: 'Postcode candidate match',
    matchUnableMatch: 'Unable to match',
    matchPublicClaimApplication: 'Public claim application',
    matchThirdReturnCallback: 'Third-party return callback',
    scenarioScenario1: 'Scenario 1',
    scenarioScenario3A: 'Scenario 3A',
    scenarioScenario3B: 'Scenario 3B',
    scenarioScenario4: 'Scenario 4',
    instructionsForward: 'Forward',
    instructionsStock: 'List on HURIX',
    instructionsDiscard: 'Discard',
    instructionsDestroy: 'Destroy',
    partiesHurixPlatform: 'HURIX Platform',
    partiesDistributorWithName: 'Distributor {name}',
    partiesOwnerWithName: 'Owner {name}',
    partiesPlatformOperationsWithName: 'Platform Operations · {name}',
    handlersWaitingDistributorClaim: 'Waiting for distributor claim',
    handlersPlatformAdjustDeadline: 'Platform Operations · deadline adjustment pending',
    handlersPlatformHurixAdmin: 'Platform Operations · hurix_admin',
    handlersOrderMatchService: 'HURIX Order Matching Service',
    handlersMatchService: 'HURIX Matching Service',
    handlersSystem: 'HURIX System',
    handlersBillingService: 'HURIX Billing Service',
    handlersPlatformOperations: 'Platform Operations',
    handlersProcessCompleted: 'Process completed',
    feesTitle: 'Fee Details',
    feesDescription: 'View handling, forwarding, and storage fees generated by distributor return parcels.',
    feesOperationTimes: 'Operations: {count}',
    feesStorageDuration: 'Storage duration: {count}',
    feesColumnsWarehouseOperations: 'Warehouse Fee / Operations',
    feesColumnsShippingFee: 'Forwarding Delivery Fee',
    feesColumnsWarehouseRent: 'Storage Fee / Duration',
    feesColumnsPaymentAmount: 'Payment Amount',
    feesColumnsPaymentStatus: 'Payment Status',
    feesColumnsPaymentInfo: 'Payment Number',
    feesColumnsCreatedAt: 'Created At',
    rulesBusinessRules: 'Business Rules',
    rulesPageTitle: 'Rules & Fees',
    rulesDescription: 'View return-processing deadlines and weight-based forwarding delivery rates.',
    rulesTimingTitle: 'Business Deadlines',
    rulesFeeTitle: 'Fee Rules',
    rulesReadOnly: 'Read-only business rule',
    rulesFreightWeightTierPricing: 'Weight-tier pricing',
    rulesFreightStartWeight: 'Starting Weight',
    rulesFreightEndWeight: 'Upper Weight',
    rulesFreightForwardingFee: 'Forwarding Fee',
    rulesFreightUnitKg: 'kg',
    rulesFreightAndAbove: 'and above',
    rulesFreightPendingConfiguration: 'Pending setup',
    rulesFreightTierStartLabel: 'Tier {number} starting weight',
    rulesFreightTierEndLabel: 'Tier {number} upper weight',
    rulesFreightTierFeeLabel: 'Tier {number} forwarding fee',
    rulesFreightRemoteAreaLink: 'View remote areas',
    rulesFreightBoundaryHint: 'The warehouse-measured weight determines the tier. A parcel exactly on a boundary belongs to the preceding tier. Only the matched tier is charged; tiers are not accumulated.',
    rulesFreightRegionsDomesticName: 'UK Mainland',
    rulesFreightRegionsDomesticDescription: 'Applies to return forwarding within non-remote UK mainland areas.',
    rulesFreightRegionsRemoteName: 'Remote Areas',
    rulesFreightRegionsRemoteDescription: 'Mainland areas include England, Wales and Scotland; remote areas refer to Northern Ireland and the Scottish Highlands. Seller category calculations consider both collections and deliveries, but delivery parcels are always charged using the delivery rate table.',
    rulesFreightRegionsOtherName: 'Other',
    rulesFreightRegionsOtherDescription: 'When a parcel contains an item that is not a HURIX product, the “Other” forwarding fee rule applies.',
    eventsPackageArrived: 'Parcel arrived at NGT warehouse',
    eventsMatchedHurixOrder: 'Matched to HURIX order',
    eventsCandidatesGenerated: 'Candidate orders generated',
    eventsEnteredPublicClaim: 'Entered public claim area',
    eventsClaimSubmitted: 'Claim application submitted',
    eventsOwnerApproved: 'Owner review approved',
    eventsInstructionPaid: 'NGT instruction submitted and paid',
    eventsAutoEnteredStorage: 'Parcel automatically entered storage',
    eventsStorageFeeStarted: 'Storage billing started',
    eventsWarehouseExecutionOverdue: 'Warehouse execution overdue',
    eventsOwnershipTransferred: 'Public claim expired; ownership transferred to platform',
    eventsEnteredDistributorStorage: 'Parcel entered distributor storage',
    eventsDistributorDiscarded: 'Distributor confirmed discard',
    eventsOrderLinkedManually: 'Order manually linked',
    eventsClaimApproved: 'Claim approved',
    eventsClaimRejected: 'Claim rejected',
    eventsPlatformInstructionIssued: 'Platform issued NGT warehouse instruction',
    eventsInstructionCompleted: 'Warehouse instruction completed',
    eventsWarehouseDeadlineAdjusted: 'Warehouse execution deadline adjusted',
    eventDescriptionsScanAndUpload: 'Scanned the return tracking number and uploaded label and outer-package photos',
    eventDescriptionsThirdOrderMatched: 'Third-party order matched; distributor notified for confirmation',
    eventDescriptionsNoThirdOrderRecognized: 'No valid third-party order number was recognised on the label',
    eventDescriptionsTwoCandidatesGenerated: 'Generated 2 candidate orders using the return postcode',
    eventDescriptionsArrivalScanCompleted: 'Warehouse arrival scan completed',
    eventDescriptionsNoReliableMatch: 'No reliable order or distributor match was found',
    eventDescriptionsOwnershipUnconfirmed: 'Parcel ownership could not be confirmed',
    eventDescriptionsClaimCountdownPaused: 'Public claim countdown paused with 5 business days 4 hours remaining',
    eventDescriptionsOwnerApprovedWithAddress: 'Return approved and return address provided',
    eventDescriptionsForwardPaid: 'Instruction: forward; payment: PAY-260916-1051',
    eventDescriptionsDistributorLinkOverdue: 'Distributor did not link the parcel within 1 business day',
    eventDescriptionsFreePeriodEnded: 'The first 3 free calendar days have ended',
    eventDescriptionsForwardPaymentSucceeded: 'Instruction: forward; payment successful',
    eventDescriptionsInstructionPaymentRemainValid: 'The original case, instruction, and payment remain valid while IT adjusts the deadline',
    eventDescriptionsClaimExpiredPlatformTask: 'Unclaimed after 7 business days; a platform disposal task was created',
    eventDescriptionsOwnerReviewCompleted: 'Waiting for the distributor to issue a warehouse instruction after owner approval',
    eventDescriptionsDistributorTransferredOwnership: 'The distributor relinquished ownership and transferred the parcel to the platform for central review',
    eventDescriptionsCandidateOrdersRejected: 'None of the candidate orders could be confirmed against the physical item',
    eventDescriptionsManualOrderLinked: 'Linked order {order}',
    eventDescriptionsClaimApprovedStorage: 'Parcel linked to the distributor and moved into storage',
    eventDescriptionsClaimRejectedCountdown: 'The remaining public claim time resumed',
    eventDescriptionsPlatformInstructionIssuedDesc: 'Instruction: {instruction}; follow the standard platform process',
    eventDescriptionsExecutionSaved: 'Execution result and handling evidence recorded',
    eventDescriptionsDeadlineAdjustedDesc: 'A new execution deadline was set; the original instruction and payment remain valid',
  },
  exclusiveLink: {
    title: 'Exclusive Promotion Link',
    linkLabel: 'Link Address',
    linkPlaceholder: 'Please enter your exclusive link',
    linkRequired: 'Link address cannot be empty',
    noLinkToCopy: 'No link to copy',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed',
    copy: 'Copy',
    tips: 'Promotion Guide',
    tip1: 'Share the distributor promotion link to invite others to register as our distributors and jointly expand the market',
    tip2: 'Share the supplier promotion link to invite quality merchants to join our supply chain for win-win cooperation',
    promotionType: 'Promotion Type',
    productPromotion: 'Distributor',
    shopPromotion: 'Supplier',
    productPromotionLink: 'Distributor Promotion Link',
    shopPromotionLink: 'Supplier Promotion Link',
    productPromotionQRCode: 'Distributor Promotion QR Code',
    shopPromotionQRCode: 'Supplier Promotion QR Code',
    clickToCopy: 'Click to copy',
    generating: 'Generating',
    qrCodeGenerating: 'QR code is generating, please try again later',
    qrCodeCopied: 'QR code image copied',
    qrCodeCopyFailed: 'Failed to copy QR code image'
  },
  shopApply: {
    salesRepresentative: 'Sales Representative',
    salesRepEmail: "Sales Representative Email",
    enterEmail: 'Please Enter Email',
    sellerEmail: 'Seller Email',
    buyerEmail: 'Buyer Email',
    sellerShopName: 'Seller / Shop Name',
    descPending: 'The seller is under review. Please wait patiently.',
    descApproved: 'The seller review has been approved and business can proceed normally.',
    descRejected: 'The seller did not pass review. Please revise and resubmit.',
    sellerDescPending: 'Seller is under review, please wait patiently.',
    sellerDescApproved: 'Seller review has been approved, business can proceed normally.',
    sellerDescRejected: 'Seller review did not pass, please revise and resubmit.',
    accountShopLabel: "Account / Shop",
    accountLabel: "Account",
    SoleTrader: "Sole Trader",
    EstablishedEntity: "Established Entity",
  },
  activity: {
    fissionActivityConfig: "Fission Activity Configuration",
  },
  newProductDetail: {
    systemAudit: "System Audit",
    manualReviewState: "Manual Review State",
    manualReviewText: "Manual Review",
    aiConfidence: "AI Confidence",
    auditResult: "Current Audit Result",
    approvedForRelease: "Approved for Release",
    rejectedForRelease: "Review Rejected",
    suggestion: "Suggestion",
    auditReason: "Audit Reason",
    violationItems: "Violation Items",
    manualReview: "Manual Review",
    pendingAction: "(Pending Action)",
    manualReviewDescription: "You can refer to the system AI record on the left to complete the second judgment",
    finalManualApprovalResult: "Final Manual Approval Result",
    reviewApprovedForRelease: "Review Approved for Release",
    reviewRejectedForRelease: "Review Rejected for Release",
    manualReviewOpinion: "Manual Review Opinion"
  },
  buyerInsight: {
    title: 'Distributor Insights',
    allDistributors: 'All Distributors',
    corePreferenceTags: 'Core Preference Tags',
    tagCount: 'Tag Count',
    ordersLast30Days: 'Orders in the Last 30 Days',
    collectionsLast30Days: 'Collections in the Last 30 Days',
    viewsLast30Days: 'Views in the Last 30 Days',
    collectionBehavior: 'Collection Activity',
    dataLast7Days: 'Last 7 Days',
    distributorEmail: 'Distributor Email',
    distributorEmailPlaceholder: 'Enter distributor email',
    enabledStatus: 'Enabled Status',
    enabledStatusPlaceholder: 'Select account enabled status',
    cancellationStatus: 'Cancellation Status',
    cancellationStatusPlaceholder: 'Select account cancellation status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    normal: 'Normal',
    deleted: 'Deleted',
    preferenceTags: 'Preference Tags',
    preferenceTagsPlaceholder: 'Select preference tags',
    createdTime: 'Created Time',
    distributorList: 'Distributor List',
    resultCount: '{count} results',
    contactDistributor: 'Contact Distributor',
    detail: 'Details',
    orderCount: '{count} orders',
    noPreferenceTags: 'No preference tags',
    dataNote: 'Statistics are based on actual behavior · Tags update on T+1',
    confirmStatusChange: 'Are you sure you want to change this distributor\'s enabled status?',
    statusUpdated: 'Enabled status updated successfully',
    noContactInfo: 'No conversation information is available for this distributor',
    justNow: 'Just now',
    minutesAgo: '{count} minutes ago',
    hoursAgo: '{count} hours ago',
    oneDayAgo: '1 day ago',
    twoDaysAgo: '2 days ago',
    daysAgo: '{count} days ago',
    activityWithinSevenDays: 'Within 7 days',
    notLoggedInRecently: 'Not logged in recently',
    backToDistributorList: 'Back to Distributor List',
    registeredAt: 'Registered at {time}',
    lastActiveAt: 'Last active {time}',
    productCategoryPreference: 'Product Category Tags · Preference Strength',
    preferenceRanking: 'Preference ranking',
    coreTag: 'Core',
    primaryTag: 'Primary',
    interestTag: 'Interest',
    newUserTag: 'New / Uncategorized',
    behaviorOverview: 'Behavior Overview',
    browseLast7Days: '7-day views',
    collectionLast7Days: '7-day collections',
    orderLast7Days: '7-day orders',
    browseLast30Days: '30-day views {count}',
    collectionCount: 'Collections {count}',
    orderQuantity: 'Orders {count}',
    orderHistory: 'Order History',
    latestOrders: 'Latest {count}',
    noOrderHistory: 'No order history',
    viewAllOrders: 'View All Orders',
    relatedProductRecommendations: 'Related Product Recommendations',
    purchased: 'Purchased',
    collected: 'Collected',
    browsed: 'Viewed',
    purchasedTimes: 'Purchased {count} times',
    noRelatedProducts: 'No related products',
    platformTagAnalysis: 'Platform Tag Analysis',
    noCategoryStatistics: 'No category statistics',
    profileRuleButton: 'Profile Rules',
    profileRules: {
      kicker: 'PROFILE GUIDE',
      title: 'Distributor Profile Rules',
      intro: 'Learn how behaviors become preference tags and how those tags are used for product recommendations.',
      close: 'Close profile rules',
      tocLabel: 'Rule contents',
      tocBehavior: 'Behavior Criteria',
      tocScore: 'Preference Scoring',
      tocTags: 'Tag Levels',
      tocUpdates: 'Update Frequency',
      tocRecommend: 'Recommendations',
      section01: '01',
      section02: '02',
      section03: '03',
      section04: '04',
      section05: '05',
      behaviorTitle: 'Which behaviors count toward the profile?',
      behaviorIntroPrefix: 'Valid distributor behaviors are grouped by ',
      behaviorIntroSubject: 'product category',
      behaviorIntroSuffix: '. Different behaviors indicate different levels of purchase intent, so they receive different weights.',
      behaviorColumn: 'Behavior',
      conditionColumn: 'Valid Condition',
      weightColumn: 'Weight',
      orderBehavior: 'Order',
      orderCondition: 'Counted after the order is paid successfully',
      orderWeight: '10',
      collectBehavior: 'Collection',
      collectCondition: 'The user clicks the product collection button',
      collectWeight: '5',
      browseBehavior: 'View',
      browseCondition: 'The user stays on the product detail page for at least 3 seconds to reduce accidental visits',
      browseWeight: '1',
      scoreTitle: 'How is the category preference score calculated?',
      scoreIntroPrefix: 'Each category is scored separately: ',
      scoreIntroStrong: 'stronger behavior, more occurrences, and more recent activity produce a higher score. ',
      scoreIntroSuffix: 'Behavior from the latest 90 days is included. Records older than 90 days are excluded, and the window can be configured.',
      scoreFormula: 'Category preference score = Σ (behavior weight × behavior count × time decay factor)',
      decayFormula: 'Time decay factor = 0.5',
      decayExponent: 'days since today ÷ 30',
      decayHint: 'The contribution of each behavior is halved every 30 days.',
      todayRatio: '100%',
      today: 'Today',
      days30Ratio: '50%',
      days30Ago: '30 days ago',
      days60Ratio: '25%',
      days60Ago: '60 days ago',
      days90Ratio: '12.5%',
      days90Ago: '90 days ago',
      scoreAccumulation: 'Each valid behavior in the same category is added once. Behaviors on different dates must be decayed separately before summing; counts may be combined directly only when their decay factors are the same.',
      exampleTitle: 'Example: three behavior groups in one category',
      exampleBrowsePrefix: '5 views with a decay factor of 1: 1 × 5 × 1 =',
      exampleBrowseScore: '5 points',
      exampleCollectPrefix: '2 collections with a decay factor of 0.8: 5 × 2 × 0.8 =',
      exampleCollectScore: '8 points',
      exampleOrderPrefix: '1 order with a decay factor of 0.9: 10 × 1 × 0.9 =',
      exampleOrderScore: '9 points',
      exampleTotalPrefix: 'The category preference score is 5 + 8 + 9 =',
      exampleTotalScore: '22 points.',
      scoreNote: 'Preference scores compare category preferences. They are not percentages and have no maximum of 100. The 7-day and 30-day behavior summaries on the page use different criteria from the profile\'s 90-day scoring window.',
      tagsTitle: 'How are preference tags generated?',
      tagsIntroPrefix: 'Each category\'s preference strength is evaluated against ',
      tagsIntroSubject: 'the distributor\'s average score across all product categories',
      tagsIntroSuffix: '. Levels are evaluated from highest to lowest, and each category receives only one tag level.',
      tagLevelColumn: 'Tag Level',
      criteriaColumn: 'Criteria',
      corePreference: 'Core Preference',
      coreCriteria: 'Category score ≥ 2× the average score',
      primaryPreference: 'Primary Preference',
      primaryCriteria: 'Category score ≥ 1.2× and < 2× the average score',
      interest: 'Interest',
      interestCriteria: 'Category score > 0 and < 1.2× the average score',
      newUser: 'New / Uncategorized',
      newUserCriteria: 'No behavior data is available for profiling',
      tagFormatPrefix: 'Tags use the format “level - category,” such as “Core Preference - Maternity & Baby.” Categories are sorted by score, and ',
      tagLimit: 'each distributor retains up to 5 tags',
      tagFormatSuffix: '.',
      tagsExample: 'For example, if the average score is 20: scores ≥ 40 are Core Preference, 24 ≤ scores < 40 are Primary Preference, and 0 < scores < 24 are Interest.',
      updatesTitle: 'When are tags updated?',
      browseUpdateDescription: 'Process the previous day\'s valid views in a nightly batch and update tags on T+1.',
      recommendTitle: 'How are preferences used for product recommendations?',
      newProductsTitle: 'Home Page “New Arrivals”',
      newProductsDescription: 'Select the distributor\'s three highest-scoring categories first and recommend new products from those categories.',
      guessYouLikeTitle: 'Home Page “You May Also Like”',
      guessYouLikeDescription: 'Select similar products from categories the distributor has viewed or collected but has not ordered, then rank them by product popularity.',
      popularityFormula: 'Product popularity references: 7-day views, collections, and sales',
      popularityHint: 'Normalize and combine the three metrics so different scales do not distort the ranking.',
      safeHint: 'Viewing these rules will not clear the current filters or switch accounts',
      returnButton: 'Back to Page'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js